// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-05T17:25:09.285Z
// Property: Park at Ferentino (ID: 6767906449167014)
// Collections: 19 amenities, 4 floorplans (live), 21 photos, 71 POIs, 1 reviews, 5 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5742705921490944",
  "multihub_property_id": "6767906449167014",
  "property_external_id": "kqr00bb",
  "property_zillow_url": "https://www.zillow.com/apartments/charlotte-nc/park-at-ferentino/5XhwKz/",
  "property_apartments_url": "https://www.apartments.com/park-at-ferentino-charlotte-nc/kqr00bb/",
  "property_google_business_url": "https://www.google.com/maps/place/The+Park+at+Ferentino/data=!4m2!3m1!1s0x0:0x626f38e45b058369?sa=X&ved=2ahUKEwjcpPuSq7ySAxXapIkEHUOzAYIQ_BJ6BAgJEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "49866408232",
  "property_crm_software": "Anyone Home",
  "property_pm_software": "AIM",
  "property_pm_info": "994PAF",
  "property_status": null,
  "property_slug": "park-at-ferentino",
  "property_name": "Park at Ferentino",
  "property_website_url": "https://www.theparkatferentino.com/",
  "property_domain": "https://www.theparkatferentino.com/",
  "property_address": "8061 Woodscape Dr",
  "property_full_address": "8061 Woodscape Dr, Charlotte, NC 28212",
  "property_address_1": "8061 Woodscape Dr",
  "property_address_2": null,
  "property_address_city": "Charlotte",
  "property_address_state": "NC",
  "property_address_zip_full": null,
  "property_address_zip": "28212",
  "property_address_country": "US",
  "property_address_county": "Mecklenburg County",
  "property_neighborhood_address": "East Forest",
  "property_address_latitude": "35.1613756",
  "property_address_longitude": "-80.74880189999999",
  "property_email": null,
  "property_phone": "(980) 414-6556",
  "property_call_tracking_phone": "8446133233",
  "property_company_name": "Apartment Management Consultants",
  "property_company_url": "https://www.liveamc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Embrace luxury living at Park at Ferentino in vibrant Charlotte, NC. Choose from stylish one and two-bedroom floor plans featuring modern interiors, large walk-in closets, and upgraded appliances. Unwind by our sparkling swimming pool or enjoy a picnic by the scenic lake. Your pet-friendly oasis awaits—discover your new home today!",
  "property_long_description": "Welcome home to The Park at Ferentino in Charlotte, North Carolina. Here you’ll find an engaging community, exquisite amenities to meet your every need, and one- and two-bedroom floorplans where you will rest and renew. Gather in our open concept floor plans with friends and family, find refreshment in the tranquility of your home or watch the sunset on your private balcony—the choice is yours. When you claim an address at The Park at SFerentino you’ll have the perfect space to easily work from home, unwind in the comforts of your own space or find an adventure that nourishes the soul in the vibrant city of Charlotte. This community is more than a place to lay your head, it’s a lifestyle.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d6-c792-77a8-9e99-3360da796cef.webp",
  "property_featured_image_media": {
    "alt_text": "Resort-style swimming pool with lounge chairs and a clubhouse.",
    "public_id": "019d02d6-c792-77a8-9e99-3360da796cef",
    "storage_key": "property/6767906449167014/019d02d6-c792-77a8-9e99-3360da796cef.webp",
    "width": 2048,
    "height": 1365
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "216",
  "property_year_built": "1980",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "94.44444444444444",
  "property_admin_fee": "175",
  "property_application_fee": "55",
  "property_fees_deposit_info": "Security Deposit\n$300-2 Month's Rent",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "350",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Maximum of 2 pets per unit.",
  "property_pet_policy_description": "Dogs and cats are welcome. One‑time non‑refundable pet fee: $350 per pet. Monthly pet rent: $25 per pet. Maximum of 2 pets per unit.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://parkatferentino.goprisma.com/auth/login",
  "property_apply_now_url": "https://www.on-site.com/apply/property/586252",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d4-6d7c-751d-89b0-e188f59523df.webp",
  "property_primary_logo_media": {
    "alt_text": "The Park at Ferentino Premier Apartment Homes logo.",
    "public_id": "019d02d4-6d7c-751d-89b0-e188f59523df",
    "storage_key": "property/6767906449167014/019d02d4-6d7c-751d-89b0-e188f59523df.webp",
    "width": 300,
    "height": 95
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d7-6fdd-70ee-a7a3-e7cb6fc1d882.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Park at Ferentino Premier Apartment Homes logo",
    "public_id": "019d02d7-6fdd-70ee-a7a3-e7cb6fc1d882",
    "storage_key": "property/6767906449167014/019d02d7-6fdd-70ee-a7a3-e7cb6fc1d882.webp",
    "width": 300,
    "height": 95
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d7-760a-764a-9197-1fae05dee05c.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Park at Ferentino Premier Apartment Homes logo",
    "public_id": "019d02d7-760a-764a-9197-1fae05dee05c",
    "storage_key": "property/6767906449167014/019d02d7-760a-764a-9197-1fae05dee05c.webp",
    "width": 300,
    "height": 95
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-5da7-768a-9221-bb30f19666be.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
  "property_company_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019d02c4-532b-737e-bc65-d92182ca8ca4",
    "storage_key": "company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
    "width": 640,
    "height": 309
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Logo for Apartment Management Consultants with a house icon.",
    "public_id": "019f6696-c195-7642-9eb0-0a4d0423bad7",
    "storage_key": "company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
    "width": 320,
    "height": 154
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019f6696-f877-771a-b04d-e0c2089d85b0",
    "storage_key": "company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
    "width": 320,
    "height": 154
  },
  "property_primary_color": "#38505a",
  "property_secondary_color": "#9b7a68",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "480 - 1,000 sq ft",
  "property_sqft_min": "480",
  "property_sqft_max": "1,000",
  "property_price_range": null,
  "property_price_min": null,
  "property_price_max": null,
  "property_available_units": 12,
  "property_facebook_url": "https://www.facebook.com/theparkatferentino/",
  "property_instagram_url": "https://www.instagram.com/parkatferentino/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ2zYx_EohVIgRaYMFW-Q4b2I",
  "property_youtube_url": "https://www.youtube.com/watch?t=966&v=JTWch86-2mc",
  "property_yelp_url": "https://www.yelp.com/biz/lakeside-apartments-charlotte",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Park at Ferentino",
  "property_home_romance_title": "Embrace Your Ideal Lifestyle in Our Charming Apartment Community",
  "property_home_amenities_blurb": "Welcome to Park at Ferentino in vibrant Charlotte, NC, where comfort meets style. Choose from spacious one and two-bedroom floor plans, featuring modern finishes and large walk-in closets. Unwind by our sparkling pool, energize in the fitness center, or relax by the scenic lake—your perfect home awaits!",
  "property_home_floorplans_blurb": "Welcome to Park at Ferentino in vibrant Charlotte, NC, where modern living meets cozy comfort. Choose from stylish one and two-bedroom floor plans designed for your lifestyle. Uncover the perfect space that captures the essence of home—browse our available apartments today and start your new chapter!",
  "property_home_gallery_blurb": "At Park at Ferentino in Charlotte, NC, experience a vibrant lifestyle with spacious one and two-bedroom floor plans. Relax by the sparkling pool, unwind in the scenic picnic area, or stay active in our modern fitness center. Embrace luxury living—picture yourself here, where comfort meets community!",
  "property_home_neighborhood_blurb": "At Park at Ferentino, vibrant living meets convenience in Charlotte, NC. Choose from our stylish one and two-bedroom floor plans and step into a neighborhood rich with culture and leisure. With nearby parks, community colleges, and fitness centers, your ideal lifestyle is just moments away. Explore local favorites today!",
  "property_home_reviews_blurb": "At Park at Ferentino in Charlotte, NC, residents rave about their vibrant community atmosphere, highlighting how “the friendly staff and beautiful surroundings make every day feel special.” Join us and see what your future neighbors have to say about a lifestyle filled with comfort and connection!",
  "property_neighborhood_blurb": "At Park at Ferentino in vibrant Charlotte, NC, enjoy a lifestyle woven into a tapestry of culture and convenience. From breathtaking parks like Freedom Park to enriching experiences at the Mint Museum Randolph, your adventure awaits just steps from home. Dive into the local scene and uncover nearby gems today!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Park at Ferentino, experience modern living in the heart of Charlotte. Choose from beautifully designed one- and two-bedroom apartments featuring upgraded appliances, large walk-in closets, and trendy finishes. Embrace community life with our sparkling pool, fitness center, and serene picnic area by the scenic lake. Discover your new home today!",
  "property_applynow_blurb": "Welcome to Park at Ferentino, your serene escape in Charlotte, NC. Choose from spacious one- or two-bedroom floor plans, each featuring modern designs and upgraded amenities. Unwind at our sparkling pool, enjoy the fitness center, or relax by the scenic lake. Find your new home and lease online today!",
  "property_contactus_blurb": "At Park at Ferentino in vibrant Charlotte, NC, our thoughtfully designed floor plans offer the perfect setting for your lifestyle. Choose from spacious one- and two-bedroom apartments, seamlessly blending comfort and convenience. Curious about our community? Reach out to our leasing team today for personalized assistance!",
  "property_faqs_blurb": "At Park at Ferentino in vibrant Charlotte, NC, our thoughtfully designed one and two-bedroom floor plans cater to your lifestyle. Curious about our community? Visit our FAQs page for insightful answers to common questions and get a glimpse of what makes living here truly exceptional. Your next home awaits!",
  "property_floorplans_blurb": "At Park at Ferentino in vibrant Charlotte, NC, our thoughtfully designed floor plans cater to every lifestyle. Whether you seek the cozy charm of a one-bedroom or the spacious comfort of a two-bedroom, each layout harmonizes style and function. Browse our available apartment homes to uncover your ideal living space!",
  "property_gallery_blurb": "At Park at Ferentino in Charlotte, NC, indulge in serene living with modern floor plans designed for your comfort. Enjoy delightful amenities like a sparkling swimming pool, state-of-the-art fitness center, and scenic picnic areas. Picture yourself embracing a vibrant lifestyle filled with convenience and charm, all in one welcoming community!",
  "property_interactivemap_blurb": "Welcome to Park at Ferentino, where modern elegance meets comfort in Charlotte, NC. Choose from spacious one- and two-bedroom plans featuring designer interiors, large walk-in closets, and upgraded appliances. Enjoy amenities like a sparkling pool, fitness center, and scenic picnic areas. Use our interactive map to find your perfect home!",
  "property_pets_blurb": "At Park at Ferentino in vibrant Charlotte, NC, your furry friends are cherished just as much as you are. Relish spacious living with a welcoming pet policy that accommodates two beloved companions. A small fee ensures a cozy home for you and your pets to thrive together in comfort.",
  "property_referafriend_blurb": "At Park at Ferentino in vibrant Charlotte, NC, your next chapter awaits in our stylish one and two-bedroom apartments. Share the joy of our welcoming community with friends—when you refer a friend, you enhance the neighborhood experience. Great friends make great neighbors; invite someone special today!",
  "property_residentaccess_blurb": "At Park at Ferentino in vibrant Charlotte, NC, our diverse floor plans cater to your lifestyle with one and two-bedroom options. Seamlessly manage your living experience—log into the resident portal for easy rent payments, maintenance requests, and more. Your convenience awaits just a click away!",
  "property_reviews_blurb": "At Park at Ferentino in Charlotte, NC, residents rave about their vibrant community, noting it's \"like living in a resort.” With lush landscapes and modern amenities, our apartments offer a lifestyle that feels like a getaway. See what our residents have to say about living at our community!",
  "property_created_at": "1769553260661",
  "property_scheduletour_blurb": "At Park at Ferentino in Charlotte, NC, our thoughtfully designed one and two-bedroom floor plans are crafted for comfort and style. Dive into vibrant community life and hear firsthand from our residents about the exceptional living experience. Schedule a tour today to envision your new beginning!",
  "property_thankyou_blurb": "Thank you for reaching out to Park at Ferentino in beautiful Charlotte, NC! Our charming one and two-bedroom floor plans offer the perfect blend of comfort and style. A team member will soon connect with you to discuss how you can call our vibrant community home.",
  "property_virtualtours_blurb": "At Park at Ferentino in vibrant Charlotte, NC, our inviting one and two-bedroom floor plans offer the perfect blend of comfort and style. Immerse yourself in our community with a virtual tour, showcasing spacious layouts and modern amenities that define upscale living. Your new home awaits! ",
  "property_copyright": "2026 All Rights Reserved. Park at Ferentino",
  "property_seo_title_home": "Park at Ferentino |  Apartments in Charlotte, NC",
  "property_seo_description_home": "Experience life at Park at Ferentino in Charlotte, NC! Enjoy modern amenities like a sparkling pool, yoga room, and scenic picnic area. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Charlotte, NC Apartments for Rent",
  "property_seo_description_floorplans": "Uncover your ideal living space at Park at Ferentino in Charlotte, NC. Choose from stylish one and two-bedroom floor plans that fit your lifestyle!",
  "property_seo_title_amenities": "Amenities | Charlotte, NC Apartments for Rent",
  "property_seo_description_amenities": "Discover vibrant living at Park at Ferentino! Enjoy resort-style amenities, including a pool and scenic lake picnic area. Your perfect home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Charlotte, NC",
  "property_seo_description_gallery": "Immerse yourself in luxury at Park at Ferentino in Charlotte, NC. See stunning spaces, from a sparkling pool to modern interiors, where your dream home awaits!",
  "property_seo_title_virtualtours": "Virtual Tours | Park at Ferentino Apartments",
  "property_seo_description_virtualtours": "Experience the charm of Park at Ferentino in Charlotte, NC. Take a virtual tour and envision your future in our spacious one and two-bedroom apartments!",
  "property_seo_title_interactivemap": "Interactive Map | Park at Ferentino Apartments",
  "property_seo_description_interactivemap": "Discover your haven at Park at Ferentino! Explore our map for one and two-bedroom apartments with great amenities in charming Charlotte, NC.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Charlotte, NC",
  "property_seo_description_neighborhood": "Experience the vibrant neighborhood of Park at Ferentino in Charlotte, NC. Uncover local gems and hotspots just steps from your new home sweet home!",
  "property_seo_title_contact": "Contact Us | Park at Ferentino",
  "property_seo_description_contact": "Connect with Park at Ferentino in Charlotte, NC! Inquire about our spacious one- and two-bedroom floor plans. Our leasing team is here to assist you!",
  "property_seo_title_faqs": "FAQs | Apartments in Charlotte, NC",
  "property_seo_description_faqs": "Get answers to all your questions about Park at Ferentino! Learn about our amenities, floor plans, and the vibrant Charlotte lifestyle that awaits you.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Charlotte, NC",
  "property_seo_description_reviews": "Join the Park at Ferentino family in Charlotte, NC! Experience modern living, fantastic amenities, and hear what our residents love most about their new home!",
  "property_seo_title_applynow": "Apply Now | Apartments in Charlotte, NC",
  "property_seo_description_applynow": "Discover luxury at Park at Ferentino, Charlotte, NC. Choose chic one or two-bedroom layouts with resort-style amenities. Lease today!",
  "property_seo_title_residentaccess": "Resident Access | Park at Ferentino",
  "property_seo_description_residentaccess": "Log in to Park at Ferentino’s resident portal in Charlotte, NC. Effortlessly pay rent, request maintenance, and manage your community life with ease!",
  "property_seo_title_referafriend": "Refer A Friend | Park at Ferentino",
  "property_seo_description_referafriend": "Refer a friend to Park at Ferentino in Charlotte, NC! Great friends make great neighbors—share the joy of vibrant living in our welcoming community today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Park at Ferentino",
  "property_seo_description_scheduletour": "Experience Charlotte living at Park at Ferentino! Schedule your tour today and see why our vibrant community is the perfect place to call home.",
  "property_seo_title_privacy": "Privacy Policy | Park at Ferentino",
  "property_seo_description_privacy": "At Park at Ferentino in Charlotte, NC, your privacy matters. Discover how we protect your information in our privacy policy. Secure your peace of mind!",
  "property_seo_title_accessibility": "Website Accessibility | Park at Ferentino",
  "property_seo_description_accessibility": "At Park at Ferentino in Charlotte, NC, we prioritize accessibility and inclusivity—because everyone deserves a comfortable home!",
  "property_seo_title_sitemap": "Sitemap | Park at Ferentino",
  "property_seo_description_sitemap": "Navigate through Park at Ferentino's offerings in Charlotte, NC. Easily access community details, amenities, and floor plans with our comprehensive sitemap.",
  "property_seo_title_thankyou": "Thank You | Park at Ferentino",
  "property_seo_description_thankyou": "Thank you for reaching out to Park at Ferentino! Our team is on the way to assist you in finding your perfect Charlotte, NC home sweet home. Stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in Charlotte, NC",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1788184617281",
  "amenities": [
    {
      "id": "ec_f7b93b143434d511ed868bb9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "generator",
      "external_id": "false",
      "title": "Sparkling Swimming Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f4e1dae0386ca949633070a3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "generator",
      "external_id": "false",
      "title": "Fitness Center with Yoga Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9909b2271b630580f365879e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "generator",
      "external_id": "false",
      "title": "Two On‑Site Laundry Facilities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_67abf2a650892baa956a5085",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "generator",
      "external_id": "false",
      "title": "Valet Trash Service",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b0823dfcfafe77df0b80d2e2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "generator",
      "external_id": "false",
      "title": "On‑Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_45a0f4c03d86b3ab25479e1d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "generator",
      "external_id": "false",
      "title": "Grilling Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1608a596c7922bc0a1d7d908",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "generator",
      "external_id": "false",
      "title": "Wi‑Fi Cafe",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a8005a03644e3571f09773e5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "generator",
      "external_id": "false",
      "title": "Picnic Area by Scenic Lake",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_367a25fc3b8fd98dd5005b83",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "generator",
      "external_id": "false",
      "title": "On‑Site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9c0c0798923cbed403a65884",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "generator",
      "external_id": "false",
      "title": "Pet Friendly Community",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ad419d529e3d841d7f4a52bb",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "generator",
      "external_id": "false",
      "title": "Carpet and Plank Style Flooring",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1f4dd4a8c4a32ef81a326c33",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "generator",
      "external_id": "false",
      "title": "Central Air & Heating",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a4c0a68ea4d07627819b4c30",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "generator",
      "external_id": "false",
      "title": "Upgraded Appliance Package in Select Units",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_37ca5196c9ce39e9bb94e6d0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "generator",
      "external_id": "false",
      "title": "Large Walk‑In Closets in Most Floorplans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4614ae9577872a58fdf7a00e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "generator",
      "external_id": "false",
      "title": "Modern Lighting Fixtures",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_680e3aee259f170f38902af9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "generator",
      "external_id": "false",
      "title": "Beveled Mirrors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_761645f2693235d2b6ac8d43",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "generator",
      "external_id": "false",
      "title": "Custom Cabinetry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_76816ed1084f0cb8dc502288",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "generator",
      "external_id": "false",
      "title": "Washer/Dryer Included in Two‑Bedroom Floorplan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_30086142cca9a2a811f92968",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "generator",
      "external_id": "false",
      "title": "Two Tone Designer Interiors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_2b2ee2ec-b9f7-4083-8aff-fbda08639222",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d4-bde0-763c-892d-dfcaccb68ca3.webp",
      "image_media": {
        "alt_text": "The Park at Ferentino Apartment Homes monument sign with landscaping.",
        "public_id": "019d02d4-bde0-763c-892d-dfcaccb68ca3",
        "storage_key": "property/6767906449167014/019d02d4-bde0-763c-892d-dfcaccb68ca3.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Welcome to The Park at Ferentino Apartment Homes, a premier community offering comfortable living and excellent amenities.",
      "link": "",
      "alt_text": "The Park at Ferentino Apartment Homes monument sign with landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_da3bad70-2916-468b-bb2c-e8f79770e1f8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d4-b995-76ef-a878-ce9768cb49fe.webp",
      "image_media": {
        "alt_text": "Welcome Center sign with landscaping and building exterior.",
        "public_id": "019d02d4-b995-76ef-a878-ce9768cb49fe",
        "storage_key": "property/6767906449167014/019d02d4-b995-76ef-a878-ce9768cb49fe.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Welcome Center sign with beautiful landscaping and the exterior of the apartment building. A welcoming entrance to the community.",
      "link": "",
      "alt_text": "Welcome Center sign with landscaping and building exterior.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_792326db-0a1f-4a93-8e90-4a18dc2d9394",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d4-b4b6-72dd-9479-9d14f30078a2.webp",
      "image_media": {
        "alt_text": "Welcome Center sign at The Park at Ferentino Premier Apartment Homes.",
        "public_id": "019d02d4-b4b6-72dd-9479-9d14f30078a2",
        "storage_key": "property/6767906449167014/019d02d4-b4b6-72dd-9479-9d14f30078a2.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Welcome Center sign for The Park at Ferentino Premier Apartment Homes, featuring lush landscaping and the property's entrance.",
      "link": "",
      "alt_text": "Welcome Center sign at The Park at Ferentino Premier Apartment Homes.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f90610af-3413-475f-8afb-0728aa1b0e08",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d4-b25c-7616-bfd3-e988f5ed7cfc.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and green landscaping.",
        "public_id": "019d02d4-b25c-7616-bfd3-e988f5ed7cfc",
        "storage_key": "property/6767906449167014/019d02d4-b25c-7616-bfd3-e988f5ed7cfc.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "A well-maintained exterior view of apartment buildings, featuring balconies and lush green landscaping, creating a welcoming community atmosphere.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with balconies and green landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0ccba5c5-92de-42a7-9d92-83f4e55d09c6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d4-acf4-77d1-9dcb-c7532761ccd6.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with covered walkways and balconies.",
        "public_id": "019d02d4-acf4-77d1-9dcb-c7532761ccd6",
        "storage_key": "property/6767906449167014/019d02d4-acf4-77d1-9dcb-c7532761ccd6.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "View of the exterior of the apartment buildings, featuring covered walkways, balconies, and surrounding greenery.",
      "link": "",
      "alt_text": "Exterior view of apartment building with covered walkways and balconies.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2c6a69ca-e82f-42db-a5b9-882c64b79e51",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d4-acaa-7538-8974-083697a8f0bb.webp",
      "image_media": {
        "alt_text": "Exterior of apartment building with balconies and green lawn.",
        "public_id": "019d02d4-acaa-7538-8974-083697a8f0bb",
        "storage_key": "property/6767906449167014/019d02d4-acaa-7538-8974-083697a8f0bb.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Exterior view of the apartment complex showcasing the building facade, balconies, and surrounding green spaces.",
      "link": "",
      "alt_text": "Exterior of apartment building with balconies and green lawn.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bf5692c7-2367-417e-8ebb-fdb09935fd44",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d4-a57d-701e-843b-b36f069fc5a3.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with a bridge and two geese in the foreground.",
        "public_id": "019d02d4-a57d-701e-843b-b36f069fc5a3",
        "storage_key": "property/6767906449167014/019d02d4-a57d-701e-843b-b36f069fc5a3.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Beautiful apartment buildings surrounded by lush greenery, featuring a charming bridge and two geese grazing. Enjoy the serene community atmosphere.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with a bridge and two geese in the foreground.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c4170666-c2c7-4716-839b-6941939c82f3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d4-a2e2-7784-a6fc-3d0c8c922869.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a clubhouse in the background.",
        "public_id": "019d02d4-a2e2-7784-a6fc-3d0c8c922869",
        "storage_key": "property/6767906449167014/019d02d4-a2e2-7784-a6fc-3d0c8c922869.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Relax and unwind by the sparkling outdoor swimming pool, complete with comfortable lounge chairs and a stylish clubhouse.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and a clubhouse in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_70bd901b-f7bf-4d63-a723-eb1600c8a9ae",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d4-9ae3-727b-9c0e-2cdef600a820.webp",
      "image_media": {
        "alt_text": "Spacious bedroom with a large king-size bed, nightstand, dresser, and closet.",
        "public_id": "019d02d4-9ae3-727b-9c0e-2cdef600a820",
        "storage_key": "property/6767906449167014/019d02d4-9ae3-727b-9c0e-2cdef600a820.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Experience ultimate comfort in our spacious bedrooms, featuring plush bedding, ample storage, and elegant decor.",
      "link": "",
      "alt_text": "Spacious bedroom with a large king-size bed, nightstand, dresser, and closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_23305d4e-3738-4886-b874-28d68b8afd57",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d4-9d07-7689-a8d7-a020ed19e9ca.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs and a clubhouse in the background.",
        "public_id": "019d02d4-9d07-7689-a8d7-a020ed19e9ca",
        "storage_key": "property/6767906449167014/019d02d4-9d07-7689-a8d7-a020ed19e9ca.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and a beautiful clubhouse area.",
      "link": "",
      "alt_text": "Outdoor swimming pool area with lounge chairs and a clubhouse in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6d0ce9e5-cfc1-402b-b12d-22095db6b7d1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d4-97b7-7389-8000-9b02787e6a9b.webp",
      "image_media": {
        "alt_text": "Business center with computers and printer",
        "public_id": "019d02d4-97b7-7389-8000-9b02787e6a9b",
        "storage_key": "property/6767906449167014/019d02d4-97b7-7389-8000-9b02787e6a9b.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Stay connected in our community business center, equipped with computers and a printer for your convenience.",
      "link": "",
      "alt_text": "Business center with computers and printer",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_912d3ee3-3da4-465f-a3b7-e83e3dbbf8c7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d4-922a-7032-a48b-35fbfbabc9b9.webp",
      "image_media": {
        "alt_text": "Fitness balls, resistance bands, and exercise mats organized in a gym.",
        "public_id": "019d02d4-922a-7032-a48b-35fbfbabc9b9",
        "storage_key": "property/6767906449167014/019d02d4-922a-7032-a48b-35fbfbabc9b9.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "State-of-the-art fitness center with a variety of equipment for your workout needs.",
      "link": "",
      "alt_text": "Fitness balls, resistance bands, and exercise mats organized in a gym.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e355d156-b2fe-4e4c-8c36-1c89b9d2bc04",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d4-8e2c-776f-99e2-b867ba057054.webp",
      "image_media": {
        "alt_text": "Fitness center with weight benches and dumbbells",
        "public_id": "019d02d4-8e2c-776f-99e2-b867ba057054",
        "storage_key": "property/6767906449167014/019d02d4-8e2c-776f-99e2-b867ba057054.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring weight benches, dumbbells, and kettlebells for a complete workout.",
      "link": "",
      "alt_text": "Fitness center with weight benches and dumbbells",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_23b83019-b840-474b-b7d2-e9ed8441cd0c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d4-8c76-7099-8c16-2784192823d3.webp",
      "image_media": {
        "alt_text": "Treadmills and exercise equipment in a community gym with outdoor seating visible through windows.",
        "public_id": "019d02d4-8c76-7099-8c16-2784192823d3",
        "storage_key": "property/6767906449167014/019d02d4-8c76-7099-8c16-2784192823d3.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with treadmills, elliptical machines, and free weights. Enjoy a workout with a view of our outdoor patio area.",
      "link": "",
      "alt_text": "Treadmills and exercise equipment in a community gym with outdoor seating visible through windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_645d26c5-62a2-486c-ae7c-5725c0138f3f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d4-89bd-767e-9ecc-d9e9e7936aca.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with granite countertops, sink, large mirror, and bathtub with shower curtain.",
        "public_id": "019d02d4-89bd-767e-9ecc-d9e9e7936aca",
        "storage_key": "property/6767906449167014/019d02d4-89bd-767e-9ecc-d9e9e7936aca.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed bathroom, featuring a spacious vanity with granite countertops, a large illuminated mirror, and a relaxing bathtub complete with a decorative shower curtain.",
      "link": "",
      "alt_text": "Bathroom vanity with granite countertops, sink, large mirror, and bathtub with shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c752a7ea-01bb-4f9d-838d-50bf1f683752",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d4-84dd-71ed-9f78-efdab4528983.webp",
      "image_media": {
        "alt_text": "Dining area with a round wooden table and four chairs. Living room with leather sofa and balcony view.",
        "public_id": "019d02d4-84dd-71ed-9f78-efdab4528983",
        "storage_key": "property/6767906449167014/019d02d4-84dd-71ed-9f78-efdab4528983.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Enjoy a meal in the dining area, or relax in the living room with a view from the balcony. This apartment offers comfortable living spaces.",
      "link": "",
      "alt_text": "Dining area with a round wooden table and four chairs. Living room with leather sofa and balcony view.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e1d0b48d-686a-46fd-9cfe-531a4a47ff5f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d4-80d7-7484-8c47-720dffb3450b.webp",
      "image_media": {
        "alt_text": "Kitchen with dark wood cabinets, black appliances, and a farmhouse sink.",
        "public_id": "019d02d4-80d7-7484-8c47-720dffb3450b",
        "storage_key": "property/6767906449167014/019d02d4-80d7-7484-8c47-720dffb3450b.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "A functional and stylish kitchen featuring dark wood cabinetry, a black range and refrigerator, and a double basin sink. Perfect for everyday cooking.",
      "link": "",
      "alt_text": "Kitchen with dark wood cabinets, black appliances, and a farmhouse sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2a3549e8-70d6-4752-bfe4-7b3bd34b8ab8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d4-7f3d-77dc-8c75-a60c1d2286dd.webp",
      "image_media": {
        "alt_text": "Kitchen and dining area with dark cabinets, granite countertops, and a round dining table.",
        "public_id": "019d02d4-7f3d-77dc-8c75-a60c1d2286dd",
        "storage_key": "property/6767906449167014/019d02d4-7f3d-77dc-8c75-a60c1d2286dd.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Spacious kitchen and dining area featuring dark wood cabinets, granite countertops, a double sink, and a comfortable dining space perfect for meals.",
      "link": "",
      "alt_text": "Kitchen and dining area with dark cabinets, granite countertops, and a round dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_84f6e12f-33ba-4eaa-8d23-0838a09eec2f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d4-7a57-77d8-903d-610b88fc6be6.webp",
      "image_media": {
        "alt_text": "Living room with a leather sofa, coffee table, fireplace, and decor.",
        "public_id": "019d02d4-7a57-77d8-903d-610b88fc6be6",
        "storage_key": "property/6767906449167014/019d02d4-7a57-77d8-903d-610b88fc6be6.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a plush leather sofa, a decorative fireplace, and elegant furnishings, perfect for relaxing.",
      "link": "",
      "alt_text": "Living room with a leather sofa, coffee table, fireplace, and decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_340e9a69-008b-4993-b349-3e446db5b157",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d4-7686-77ed-804a-283cbf77de97.webp",
      "image_media": {
        "alt_text": "Living room with fireplace, large sliding glass door, and ornate rug.",
        "public_id": "019d02d4-7686-77ed-804a-283cbf77de97",
        "storage_key": "property/6767906449167014/019d02d4-7686-77ed-804a-283cbf77de97.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a white brick fireplace with decorative accents, a sliding glass door leading to a balcony, and a traditional rug.",
      "link": "",
      "alt_text": "Living room with fireplace, large sliding glass door, and ornate rug.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b202c5d2-4e8a-407a-ba77-f6b7bc4a75d3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d4-7510-76b5-8b46-dd87fbaea8b4.webp",
      "image_media": {
        "alt_text": "Living room with a leather sofa, fireplace, and balcony access.",
        "public_id": "019d02d4-7510-76b5-8b46-dd87fbaea8b4",
        "storage_key": "property/6767906449167014/019d02d4-7510-76b5-8b46-dd87fbaea8b4.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a comfortable leather sofa, a cozy fireplace, and access to a private balcony overlooking the scenic outdoors.",
      "link": "",
      "alt_text": "Living room with a leather sofa, fireplace, and balcony access.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_750040c1-9648-407e-94ac-d63109432491",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "Night Swim Coffee Oakhurst",
      "poi_type": "Restaurants",
      "poi_address": "1620 Oakhurst Commons Dr Suite 306, Charlotte, NC 28205, USA",
      "poi_short_description": "Casual coffee shop specializing in espresso-based drinks and avocado toast.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d4-d980-777f-853c-9577120b5c96.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-d980-777f-853c-9577120b5c96",
        "storage_key": "property/6767906449167014/019d02d4-d980-777f-853c-9577120b5c96.webp",
        "width": 830,
        "height": 1280
      },
      "poi_business_url": "http://www.nightswimcoffee.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12383484714881306209&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "night-swim-coffee-oakhurst",
      "poi_latitude": "35.1937954",
      "poi_longitude": "-80.78176049999999",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 704-503-9212",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-5ae0-75d8-a87d-9a6065ea377a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-5ae0-75d8-a87d-9a6065ea377a",
        "storage_key": "property/6767906449167014/019d02d5-5ae0-75d8-a87d-9a6065ea377a.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJUdrm1RchVIgRYc7617z52qs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_554642d7-5e66-4af0-9588-0afe174159a5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "King Crab Shake Shake",
      "poi_type": "Restaurants",
      "poi_address": "7401 E Independence Blvd, Charlotte, NC 28227, USA",
      "poi_short_description": "A menu focused on an array of steamed seafood platters & comfort dishes in a relaxed setting.",
      "poi_long_description": "A menu focused on an array of steamed seafood platters & comfort dishes in a relaxed setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d4-d943-7259-9d3e-88cbf1ea58f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-d943-7259-9d3e-88cbf1ea58f7",
        "storage_key": "property/6767906449167014/019d02d4-d943-7259-9d3e-88cbf1ea58f7.webp",
        "width": 1080,
        "height": 609
      },
      "poi_business_url": "https://www.shakeshakeseafoods.com/?fbclid=PAZXh0bgNhZW0CMTEAAaaoWLDAlNiK0Z7xgBNiAXu45AF-ZsvDVWa8_-5rDi8e7Ej_-YsLmbNQcQU_aem_ATI_VQgZ9qiYcsBpRT0l5jxYVS2alkIcH7_FvDWxi7w5SsmCTa7c5PDIMOG4BBhANAmqbNbK_h7PPynxOp5hmTzj",
      "poi_directions_map_url": "https://maps.google.com/?cid=3180687589246950098&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "king-crab-shake-shake",
      "poi_latitude": "35.16180190000001",
      "poi_longitude": "-80.737691",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 980-299-0029",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-5aea-77ff-9d7f-abf99a1c4612.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-5aea-77ff-9d7f-abf99a1c4612",
        "storage_key": "property/6767906449167014/019d02d5-5aea-77ff-9d7f-abf99a1c4612.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJR2IT4a8hVIgR0tqOqoISJCw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_5b0929da-4845-405f-ad7e-faa86553f5a0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "Phở Hương Que",
      "poi_type": "Restaurants",
      "poi_address": "7211 E Independence Blvd, Charlotte, NC 28227, USA",
      "poi_short_description": "Vietnamese soup house also offering rice dishes & stir-fries with juice, coffee, bubble tea & beer.",
      "poi_long_description": "Vietnamese soup house also offering rice dishes & stir-fries with juice, coffee, bubble tea & beer.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d4-d9bc-701a-8b80-f72b0f16334b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-d9bc-701a-8b80-f72b0f16334b",
        "storage_key": "property/6767906449167014/019d02d4-d9bc-701a-8b80-f72b0f16334b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5507240776404047757&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ph-hng-que",
      "poi_latitude": "35.1637268",
      "poi_longitude": "-80.73897029999999",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 704-536-0401",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-5aea-77ff-9d7f-abf99a1c4612.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-5aea-77ff-9d7f-abf99a1c4612",
        "storage_key": "property/6767906449167014/019d02d5-5aea-77ff-9d7f-abf99a1c4612.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8yL2OXQhVIgRjRccuk6mbUw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "vietnamese_restaurant"
    },
    {
      "id": "custom_c72815aa-7fdb-4ebc-9be4-229828d32504",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "La Shish Kabob",
      "poi_type": "Restaurants",
      "poi_address": "3117 N Sharon Amity Rd, Charlotte, NC 28205, USA",
      "poi_short_description": "Plain counter serve prepping halal Middle Eastern bites such as shawarma, falafel & grilled skewers.",
      "poi_long_description": "Plain counter serve prepping halal Middle Eastern bites such as shawarma, falafel & grilled skewers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d4-e0e4-77e4-b687-12733034e0fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-e0e4-77e4-b687-12733034e0fb",
        "storage_key": "property/6767906449167014/019d02d4-e0e4-77e4-b687-12733034e0fb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://lashishkabob.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9095322895163739355&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-shish-kabob",
      "poi_latitude": "35.2028663",
      "poi_longitude": "-80.7609796",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 704-567-7900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-5aea-77ff-9d7f-abf99a1c4612.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-5aea-77ff-9d7f-abf99a1c4612",
        "storage_key": "property/6767906449167014/019d02d5-5aea-77ff-9d7f-abf99a1c4612.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7VfzF9IhVIgR20y26_sTOX4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "middle_eastern_restaurant"
    },
    {
      "id": "custom_0df3c594-95ec-4516-95a8-3f1ac24792e5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "Rooster's Wood-fired Kitchen Ballantyne",
      "poi_type": "Restaurants",
      "poi_address": "15110 Bowl St #101, Charlotte, NC 28277, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d4-e0cf-75b6-91c2-f1771e6f8ad8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-e0cf-75b6-91c2-f1771e6f8ad8",
        "storage_key": "property/6767906449167014/019d02d4-e0cf-75b6-91c2-f1771e6f8ad8.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.roosterskitchen.com/ballantyne",
      "poi_directions_map_url": "https://maps.google.com/?cid=17093347024850541206&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "roosters-wood-fired-kitchen-ballantyne",
      "poi_latitude": "35.0573504",
      "poi_longitude": "-80.84518539999999",
      "poi_miles_from_property": "11.4",
      "poi_walking_minutes": "4 hours 10 mins",
      "poi_biking_minutes": "1 hour 6 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 980-366-1010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-5ae4-7266-843e-aae0738d7e07.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-5ae4-7266-843e-aae0738d7e07",
        "storage_key": "property/6767906449167014/019d02d5-5ae4-7266-843e-aae0738d7e07.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeRUUGiWdVogRllqy_o3EN-0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_324e06ee-d77f-4ec9-9f8b-8904301fc1e6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "Bossy Beulah's Ballantyne",
      "poi_type": "Restaurants",
      "poi_address": "15110 Bowl St #103, Charlotte, NC 28277, USA",
      "poi_short_description": "Fried, flavorful chicken sandwiches are the specialty at this casual eatery with outdoor seating.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d4-e12a-7109-8d7e-ebda4020b2bc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-e12a-7109-8d7e-ebda4020b2bc",
        "storage_key": "property/6767906449167014/019d02d4-e12a-7109-8d7e-ebda4020b2bc.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://bossybeulahs.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8953534312420350164&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bossy-beulahs-ballantyne",
      "poi_latitude": "35.0574827",
      "poi_longitude": "-80.845114",
      "poi_miles_from_property": "11.4",
      "poi_walking_minutes": "4 hours 9 mins",
      "poi_biking_minutes": "1 hour 6 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 980-366-1020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-5aea-77ff-9d7f-abf99a1c4612.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-5aea-77ff-9d7f-abf99a1c4612",
        "storage_key": "property/6767906449167014/019d02d5-5aea-77ff-9d7f-abf99a1c4612.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJx9hkSUadVogR1BgW8ARYQXw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_7774b848-fe33-4b1b-8dc3-3346a07b7f3f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "Flower Child",
      "poi_type": "Restaurants",
      "poi_address": "15210 Bowl St #101, Charlotte, NC 28277, USA",
      "poi_short_description": "Casual eatery (part of a chain) serving bowls, wraps, salads and kabobs.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d4-e1c7-757e-bf04-61a9af32c2e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-e1c7-757e-bf04-61a9af32c2e3",
        "storage_key": "property/6767906449167014/019d02d4-e1c7-757e-bf04-61a9af32c2e3.webp",
        "width": 1000,
        "height": 1000
      },
      "poi_business_url": "https://www.iamaflowerchild.com/locations/flower-child-charlotte-ballantyne/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17187131514142165411&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "flower-child",
      "poi_latitude": "35.0583156",
      "poi_longitude": "-80.8455975",
      "poi_miles_from_property": "11.3",
      "poi_walking_minutes": "4 hours 8 mins",
      "poi_biking_minutes": "1 hour 6 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 980-279-5793",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-5aea-77ff-9d7f-abf99a1c4612.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-5aea-77ff-9d7f-abf99a1c4612",
        "storage_key": "property/6767906449167014/019d02d5-5aea-77ff-9d7f-abf99a1c4612.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJOaJvtuWdVogRo4ldAA31hO4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_8e41828b-16fb-402f-bb11-eb7375112b3e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "North Italia",
      "poi_type": "Restaurants",
      "poi_address": "15120 Bowl St #102, Charlotte, NC 28277, USA",
      "poi_short_description": "Laid-back, trendy chain eatery for Italian fare such as pizza, pasta and cocktails in modern surroundings.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d4-e840-709f-bd11-bd2ab85b26a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-e840-709f-bd11-bd2ab85b26a2",
        "storage_key": "property/6767906449167014/019d02d4-e840-709f-bd11-bd2ab85b26a2.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.northitalia.com/locations/ballantyne-nc/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18408571823897907174&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-italia",
      "poi_latitude": "35.0579049",
      "poi_longitude": "-80.84532",
      "poi_miles_from_property": "11.4",
      "poi_walking_minutes": "4 hours 9 mins",
      "poi_biking_minutes": "1 hour 6 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 980-431-6225",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-5aea-77ff-9d7f-abf99a1c4612.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-5aea-77ff-9d7f-abf99a1c4612",
        "storage_key": "property/6767906449167014/019d02d5-5aea-77ff-9d7f-abf99a1c4612.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJlcVBmnidVogR5g-zgYpieP8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_2187db22-57b7-4732-b0a8-827ca9d47ad8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "SushiHana Ballantyne",
      "poi_type": "Restaurants",
      "poi_address": "15719 Brixham Hill Ave, Charlotte, NC 28277, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d4-e873-71d9-8f52-b94a8f7f3436.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-e873-71d9-8f52-b94a8f7f3436",
        "storage_key": "property/6767906449167014/019d02d4-e873-71d9-8f52-b94a8f7f3436.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://ballantyne.sushihanaclt.com/charlotte-ballantyne-sushi-hana-ballantyne-food-menu",
      "poi_directions_map_url": "https://maps.google.com/?cid=4324087354269400638&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sushihana-ballantyne",
      "poi_latitude": "35.0578902",
      "poi_longitude": "-80.85126240000001",
      "poi_miles_from_property": "11.3",
      "poi_walking_minutes": "4 hours 8 mins",
      "poi_biking_minutes": "1 hour 6 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 704-910-3636",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-5aea-77ff-9d7f-abf99a1c4612.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-5aea-77ff-9d7f-abf99a1c4612",
        "storage_key": "property/6767906449167014/019d02d5-5aea-77ff-9d7f-abf99a1c4612.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJxyEl5lmdVogRPn786Ik-Ajw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_81b266a1-c167-4e52-9846-de548e757f7f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "Juliana Pizza",
      "poi_type": "Restaurants",
      "poi_address": "9858 Monroe Rd, Charlotte, NC 28270, USA",
      "poi_short_description": "Sub, pizza, and Greek-style menu items in a family-run joint with a casual atmosphere.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d4-e8b5-72e9-aabc-3c79bcf4a42b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-e8b5-72e9-aabc-3c79bcf4a42b",
        "storage_key": "property/6767906449167014/019d02d4-e8b5-72e9-aabc-3c79bcf4a42b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=18373961062863600481&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "juliana-pizza",
      "poi_latitude": "35.1375002",
      "poi_longitude": "-80.73942290000001",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 704-847-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-5aea-77ff-9d7f-abf99a1c4612.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-5aea-77ff-9d7f-abf99a1c4612",
        "storage_key": "property/6767906449167014/019d02d5-5aea-77ff-9d7f-abf99a1c4612.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJnWgFi0YhVIgRYfvXvDxs_f4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_8e1896e1-227e-43de-8c04-071c08fb0769",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "4006 Connection Point Blvd, Charlotte, NC 28212, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d4-e873-71d9-8f52-b5c957b2ce2d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-e873-71d9-8f52-b5c957b2ce2d",
        "storage_key": "property/6767906449167014/019d02d4-e873-71d9-8f52-b5c957b2ce2d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.aldi.us/stores/l/nc/charlotte/4006-connection-point-blvd/f931",
      "poi_directions_map_url": "https://maps.google.com/?cid=16374210266330386077&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "35.185057",
      "poi_longitude": "-80.761388",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-5ae5-724c-a7e7-1efcb3412ec0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-5ae5-724c-a7e7-1efcb3412ec0",
        "storage_key": "property/6767906449167014/019d02d5-5ae5-724c-a7e7-1efcb3412ec0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJue21jbMhVIgRnU4tonvhPOM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_a6ba9f3d-08cd-4674-8858-8f1bd534ea9c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "Walmart Neighborhood Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "8800 E W.T. Harris Blvd, Charlotte, NC 28227, USA",
      "poi_short_description": "Chain featuring groceries and household items, plus a pharmacy and friendly staff, all in a busy setting.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d4-ef34-73ab-a2db-4b22a741cc95.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-ef34-73ab-a2db-4b22a741cc95",
        "storage_key": "property/6767906449167014/019d02d4-ef34-73ab-a2db-4b22a741cc95.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walmart.com/store/4148-charlotte-nc/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=9934521177441895102&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-neighborhood-market",
      "poi_latitude": "35.2007129",
      "poi_longitude": "-80.7274226",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 704-916-1891",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-5ae5-724c-a7e7-1efcb3412ec0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-5ae5-724c-a7e7-1efcb3412ec0",
        "storage_key": "property/6767906449167014/019d02d5-5ae5-724c-a7e7-1efcb3412ec0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-cThI_ohVIgRvgIFI2CC3ok",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_cac2d397-f3f1-49bc-9a0b-870dc1c77cc3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "3850 E Independence Blvd, Charlotte, NC 28205, USA",
      "poi_short_description": "Big-box retailer offering electronics and home decor, furniture, toys and apparel, plus groceries and a pharmacy.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d4-ef10-7355-a88a-149120f3f252.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-ef10-7355-a88a-149120f3f252",
        "storage_key": "property/6767906449167014/019d02d4-ef10-7355-a88a-149120f3f252.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/1666-charlotte-nc/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=1318675723632911923&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "35.1992961",
      "poi_longitude": "-80.7766882",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 704-535-3708",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-6056-75bc-9de9-fc3630936a83.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-6056-75bc-9de9-fc3630936a83",
        "storage_key": "property/6767906449167014/019d02d5-6056-75bc-9de9-fc3630936a83.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ3eVKPSEgVIgRMyYSgZXgTBI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_6cbd39c3-948a-42d3-a697-db25b9aa713c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "Mana International Supermarket",
      "poi_type": "Shopping & Retail",
      "poi_address": "6319 Albemarle Rd, Charlotte, NC 28212, USA",
      "poi_short_description": "Grocery store at Four Seasons Plaza with a wide selection of international foods.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d4-f044-7219-be2a-fb49bec8f29e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-f044-7219-be2a-fb49bec8f29e",
        "storage_key": "property/6767906449167014/019d02d4-f044-7219-be2a-fb49bec8f29e.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "http://facebook.com/manasupermarket",
      "poi_directions_map_url": "https://maps.google.com/?cid=14365195310403522903&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mana-international-supermarket",
      "poi_latitude": "35.2039737",
      "poi_longitude": "-80.7374796",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 980-406-3636",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-5ae5-724c-a7e7-1efcb3412ec0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-5ae5-724c-a7e7-1efcb3412ec0",
        "storage_key": "property/6767906449167014/019d02d5-5ae5-724c-a7e7-1efcb3412ec0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXZzDerEhVIgRV5G1VQZtW8c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_11ae49e7-1ca9-4a88-848d-c5d1dae51f1a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "Central Market Charlotte- Indian/ Nepali Store",
      "poi_type": "Shopping & Retail",
      "poi_address": "6413 Albemarle Rd, Charlotte, NC 28212, USA",
      "poi_short_description": "Indian grocery store featuring traditional clothing, snacks, spices, and other imported items, along with chatpate.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d4-f049-718f-9401-de2e826c4bc5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-f049-718f-9401-de2e826c4bc5",
        "storage_key": "property/6767906449167014/019d02d4-f049-718f-9401-de2e826c4bc5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.centralmarketcharlotte.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4519470050664817434&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "central-market-charlotte--indian-nepali-store",
      "poi_latitude": "35.2032806",
      "poi_longitude": "-80.73597509999999",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 980-224-9978",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-5ae5-724c-a7e7-1efcb3412ec0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-5ae5-724c-a7e7-1efcb3412ec0",
        "storage_key": "property/6767906449167014/019d02d5-5ae5-724c-a7e7-1efcb3412ec0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMbM7jPYfVIgRGqPk3hBiuD4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_400d2dc7-9b92-4eda-b762-7c3f113660ac",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "Dollar General",
      "poi_type": "Shopping & Retail",
      "poi_address": "5200 Albemarle Rd, Charlotte, NC 28212, USA",
      "poi_short_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_long_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d4-f64f-770d-89fe-92b651e70552.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-f64f-770d-89fe-92b651e70552",
        "storage_key": "property/6767906449167014/019d02d4-f64f-770d-89fe-92b651e70552.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dollargeneral.com/store-directory/nc/charlotte/12207",
      "poi_directions_map_url": "https://maps.google.com/?cid=9336872184443434271&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-general",
      "poi_latitude": "35.2012269",
      "poi_longitude": "-80.76009479999999",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 980-349-5451",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-6056-75bc-9de9-fc3630936a83.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-6056-75bc-9de9-fc3630936a83",
        "storage_key": "property/6767906449167014/019d02d5-6056-75bc-9de9-fc3630936a83.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ0-QmB84hVIgRH_X5asg7k4E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_7396c3bf-5c71-408c-b8e0-0555c3ac15de",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "Royal Express Mart Inc",
      "poi_type": "Shopping & Retail",
      "poi_address": "5933 Albemarle Rd # A, Charlotte, NC 28212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d4-f657-7474-8305-3005f7ac2296.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-f657-7474-8305-3005f7ac2296",
        "storage_key": "property/6767906449167014/019d02d4-f657-7474-8305-3005f7ac2296.webp",
        "width": 1280,
        "height": 817
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9179865026262217688&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "royal-express-mart-inc",
      "poi_latitude": "35.203863",
      "poi_longitude": "-80.744055",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 704-537-8860",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-6063-705d-9c21-0eea0376b4cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-6063-705d-9c21-0eea0376b4cb",
        "storage_key": "property/6767906449167014/019d02d5-6063-705d-9c21-0eea0376b4cb.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJbTIVj90hVIgR2DNkuJpuZX8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_390a9c27-4f79-4b45-a0ac-b34f3f056d66",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "Ross Dress for Less",
      "poi_type": "Shopping & Retail",
      "poi_address": "3201 Eastway Dr, Charlotte, NC 28205, USA",
      "poi_short_description": "Retail chain selling brand-name clothing, shoes, accessories & housewares at discount prices.",
      "poi_long_description": "Retail chain selling brand-name clothing, shoes, accessories & housewares at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d4-f7b9-77cb-a1cf-82c53da6da7c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-f7b9-77cb-a1cf-82c53da6da7c",
        "storage_key": "property/6767906449167014/019d02d4-f7b9-77cb-a1cf-82c53da6da7c.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.rossstores.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16322641153048609433&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ross-dress-for-less",
      "poi_latitude": "35.2114723",
      "poi_longitude": "-80.7796137",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 704-535-8798",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-6056-75bc-9de9-fc3630936a83.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-6056-75bc-9de9-fc3630936a83",
        "storage_key": "property/6767906449167014/019d02d5-6056-75bc-9de9-fc3630936a83.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ3SdyqicgVIgRmYKiy6WrheI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_9ed96a84-7f23-41f9-9808-ae294516b792",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "Greenway Park Elementary",
      "poi_type": "Education",
      "poi_address": "8301 Monroe Rd, Charlotte, NC 28212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.cmsk12.org/greenwayparkES",
      "poi_directions_map_url": "https://maps.google.com/?cid=17266232777522328793&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greenway-park-elementary",
      "poi_latitude": "35.1573159",
      "poi_longitude": "-80.74673159999999",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 980-343-5060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-6063-705d-9c21-11a04a8ebb76.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-6063-705d-9c21-11a04a8ebb76",
        "storage_key": "property/6767906449167014/019d02d5-6063-705d-9c21-11a04a8ebb76.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJN7S3ew0hVIgR2bRsETv7ne8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_cc0af5df-2585-4d57-b4f5-e482b24c284d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "McClintock Middle School",
      "poi_type": "Education",
      "poi_address": "1925 Rama Rd, Charlotte, NC 28212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d4-fc35-71e9-b953-6c4bbe73947a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-fc35-71e9-b953-6c4bbe73947a",
        "storage_key": "property/6767906449167014/019d02d4-fc35-71e9-b953-6c4bbe73947a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cmsk12.org/mcclintockMS",
      "poi_directions_map_url": "https://maps.google.com/?cid=9026744456924110823&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mcclintock-middle-school",
      "poi_latitude": "35.1797124",
      "poi_longitude": "-80.7688498",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 980-343-6425",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-6063-705d-9c21-11a04a8ebb76.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-6063-705d-9c21-11a04a8ebb76",
        "storage_key": "property/6767906449167014/019d02d5-6063-705d-9c21-11a04a8ebb76.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJX8SJZ00gVIgR5x8wAUJwRX0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_e84e44c2-2b86-4d63-8319-58d3cf2b7100",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "East Mecklenburg High School",
      "poi_type": "Education",
      "poi_address": "6800 Monroe Rd, Charlotte, NC 28212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d4-fcd3-707d-ade7-d4a67b08a84f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-fcd3-707d-ade7-d4a67b08a84f",
        "storage_key": "property/6767906449167014/019d02d4-fcd3-707d-ade7-d4a67b08a84f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cmsk12.org/eastmecklenburgHS",
      "poi_directions_map_url": "https://maps.google.com/?cid=12431494909418291657&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "east-mecklenburg-high-school",
      "poi_latitude": "35.1752502",
      "poi_longitude": "-80.7579975",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 980-343-6430",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-6063-705d-9c21-11a04a8ebb76.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-6063-705d-9c21-11a04a8ebb76",
        "storage_key": "property/6767906449167014/019d02d5-6063-705d-9c21-11a04a8ebb76.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJsbaH3K4hVIgRyUH0VsGKhaw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_b4ee32d9-a186-4d34-a7be-13ac159d233a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "Farm Pond KinderCare",
      "poi_type": "Education",
      "poi_address": "5750 Farm Pond Ln, Charlotte, NC 28212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d4-fcd3-707d-ade7-d8697e1bdad3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-fcd3-707d-ade7-d8697e1bdad3",
        "storage_key": "property/6767906449167014/019d02d4-fcd3-707d-ade7-d8697e1bdad3.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "https://www.kindercare.com/our-centers/charlotte/nc/300501?utm_campaign=kc-lg&utm_source=yext&utm_medium=pro&utm_keyword=&utm_platform=&utm_matchtype=&utm_adgroupid=&utm_content=gmb&y_source=1_NTA3MjcxLTcxNS1sb2NhdGlvbi53ZWJzaXRl",
      "poi_directions_map_url": "https://maps.google.com/?cid=16693837204571620399&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "farm-pond-kindercare",
      "poi_latitude": "35.2011692",
      "poi_longitude": "-80.7395691",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 704-568-2419",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-6063-705d-9c21-11a04a8ebb76.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-6063-705d-9c21-11a04a8ebb76",
        "storage_key": "property/6767906449167014/019d02d5-6063-705d-9c21-11a04a8ebb76.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ9VJAPuYhVIgRLwSxZH1srOc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_ea960226-e65c-4061-b1d3-e430482cc950",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "The Butterfly Garden Child Development Center",
      "poi_type": "Education",
      "poi_address": "6610 Ware Rd, Charlotte, NC 28212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d4-fe1f-74a8-ba28-4b912df8f58b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-fe1f-74a8-ba28-4b912df8f58b",
        "storage_key": "property/6767906449167014/019d02d4-fe1f-74a8-ba28-4b912df8f58b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.butterflygardenchilddevelopment.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17211434214281267991&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-butterfly-garden-child-development-center",
      "poi_latitude": "35.1862334",
      "poi_longitude": "-80.7326369",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 704-531-1116",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-6063-705d-9c21-11a04a8ebb76.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-6063-705d-9c21-11a04a8ebb76",
        "storage_key": "property/6767906449167014/019d02d5-6063-705d-9c21-11a04a8ebb76.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVVUhgpIhVIgRF0s9UTpM2-4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_84f529dd-9330-4e95-8532-de2fad1477e5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "Central Piedmont Community College - Levine Campus",
      "poi_type": "Education",
      "poi_address": "2800 Campus Ridge Rd Suite 1113, Matthews, NC 28105, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-0429-739d-8944-b081c36af875.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-0429-739d-8944-b081c36af875",
        "storage_key": "property/6767906449167014/019d02d5-0429-739d-8944-b081c36af875.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cpcc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10540439868142705401&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "central-piedmont-community-college---levine-campus",
      "poi_latitude": "35.1061053",
      "poi_longitude": "-80.69308509999999",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 704-330-2722",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-6063-705d-9c21-11a04a8ebb76.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-6063-705d-9c21-11a04a8ebb76",
        "storage_key": "property/6767906449167014/019d02d5-6063-705d-9c21-11a04a8ebb76.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJCSbwKmwkVIgR-doC5TYqR5I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_532a3f74-d3eb-49a4-be72-b5baf6fcca6f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "Queens University of Charlotte",
      "poi_type": "Education",
      "poi_address": "1900 Selwyn Ave, Charlotte, NC 28274, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-0429-739d-8944-b78c16e5b504.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-0429-739d-8944-b78c16e5b504",
        "storage_key": "property/6767906449167014/019d02d5-0429-739d-8944-b78c16e5b504.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.queens.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7142315374379760541&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "queens-university-of-charlotte",
      "poi_latitude": "35.188626",
      "poi_longitude": "-80.83297240000002",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 704-337-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-6063-705d-9c21-11a04a8ebb76.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-6063-705d-9c21-11a04a8ebb76",
        "storage_key": "property/6767906449167014/019d02d5-6063-705d-9c21-11a04a8ebb76.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJuWwm87ifVogRnXu3y_2ZHmM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_66c56ad6-d450-461a-b533-79e4255d7632",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "Truliant Amphitheater",
      "poi_type": "Entertainment",
      "poi_address": "707 Pavilion Blvd, Charlotte, NC 28262, USA",
      "poi_short_description": "Sprawling outdoor venue for a variety of musical acts, from country to R&B, plus festivals & events.",
      "poi_long_description": "Sprawling outdoor venue for a variety of musical acts, from country to R&B, plus festivals & events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-05b4-77ff-8b41-78881dd714f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-05b4-77ff-8b41-78881dd714f9",
        "storage_key": "property/6767906449167014/019d02d5-05b4-77ff-8b41-78881dd714f9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.truliantamp.com/?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=8876681391951831978&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "truliant-amphitheater",
      "poi_latitude": "35.3271592",
      "poi_longitude": "-80.7123113",
      "poi_miles_from_property": "21.5",
      "poi_walking_minutes": "7 hours 57 mins",
      "poi_biking_minutes": "1 hour 30 mins",
      "poi_driving_minutes": "30 mins",
      "poi_business_phone": "+1 704-549-5555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-5ae4-7266-843e-aae0738d7e07.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-5ae4-7266-843e-aae0738d7e07",
        "storage_key": "property/6767906449167014/019d02d5-5ae4-7266-843e-aae0738d7e07.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC2hDco8bVIgRquOb_7FOMHs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amphitheatre"
    },
    {
      "id": "custom_a8132c75-62e8-438e-a370-abb4642798f0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "Regal Starlight - Charlotte",
      "poi_type": "Entertainment",
      "poi_address": "11240 N Tryon St, Charlotte, NC 28262, USA",
      "poi_short_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_long_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-0ad7-7024-a874-596de5f45dab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-0ad7-7024-a874-596de5f45dab",
        "storage_key": "property/6767906449167014/019d02d5-0ad7-7024-a874-596de5f45dab.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.regmovies.com/theatres/regal-starlight-charlotte-1848?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=3793897542016868716&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "regal-starlight---charlotte",
      "poi_latitude": "35.33325",
      "poi_longitude": "-80.71723999999999",
      "poi_miles_from_property": "21.8",
      "poi_walking_minutes": "8 hours 2 mins",
      "poi_biking_minutes": "1 hour 33 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "+1 844-462-7342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-60b4-700c-84a0-2ff6bf657a20.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-60b4-700c-84a0-2ff6bf657a20",
        "storage_key": "property/6767906449167014/019d02d5-60b4-700c-84a0-2ff6bf657a20.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJr_JJhCZ_WIgRbKEkqrahpjQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_dc080c46-e7c3-429f-90f1-dab20b766d5e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "Edge City Brewery",
      "poi_type": "Entertainment",
      "poi_address": "6209 Old Post Rd Suite 109, Charlotte, NC 28212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d4-d92e-73ce-a042-35e486afeefe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-d92e-73ce-a042-35e486afeefe",
        "storage_key": "property/6767906449167014/019d02d4-d92e-73ce-a042-35e486afeefe.webp",
        "width": 828,
        "height": 817
      },
      "poi_business_url": "http://edgecitybrewery-clt.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13343162074611426893&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "edge-city-brewery",
      "poi_latitude": "35.1776683",
      "poi_longitude": "-80.7561267",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 980-505-1092",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-5ae4-7266-843e-aae0738d7e07.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-5ae4-7266-843e-aae0738d7e07",
        "storage_key": "property/6767906449167014/019d02d5-5ae4-7266-843e-aae0738d7e07.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAZ9LAIIhVIgRTaatNTZvLLk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "food"
    },
    {
      "id": "custom_71c1c639-fd5d-4841-8167-e38711b40c1b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "UNC Charlotte Botanical Gardens",
      "poi_type": "Entertainment",
      "poi_address": "9090 Craver Rd, Charlotte, NC 28262, USA",
      "poi_short_description": "Indoor & outdoor displays of plants from around the world, plus workshops, plant sales & free tours.",
      "poi_long_description": "Indoor & outdoor displays of plants from around the world, plus workshops, plant sales & free tours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-0c23-7736-b3ce-1ad3336fe4b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-0c23-7736-b3ce-1ad3336fe4b3",
        "storage_key": "property/6767906449167014/019d02d5-0c23-7736-b3ce-1ad3336fe4b3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://gardens.uncc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4177973296962421892&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "unc-charlotte-botanical-gardens",
      "poi_latitude": "35.3078198",
      "poi_longitude": "-80.72969499999999",
      "poi_miles_from_property": "12.2",
      "poi_walking_minutes": "4 hours 30 mins",
      "poi_biking_minutes": "1 hour 22 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 704-687-0721",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-6599-7772-afdf-47b7293a5073.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-6599-7772-afdf-47b7293a5073",
        "storage_key": "property/6767906449167014/019d02d5-6599-7772-afdf-47b7293a5073.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJA6cM9xocVIgRhESD5pMk-zk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_64880c7f-744b-4cc2-995b-ee78dc2777ee",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "Topgolf Charlotte - University",
      "poi_type": "Entertainment",
      "poi_address": "9110 Drivers Wy, Charlotte, NC 28262, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-0e33-77be-b5f2-d192f58b0d94.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-0e33-77be-b5f2-d192f58b0d94",
        "storage_key": "property/6767906449167014/019d02d5-0e33-77be-b5f2-d192f58b0d94.webp",
        "width": 1280,
        "height": 733
      },
      "poi_business_url": "https://topgolf.com/us/charlotte-university/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14916876276335703365&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "topgolf-charlotte---university",
      "poi_latitude": "35.2875467",
      "poi_longitude": "-80.7702764",
      "poi_miles_from_property": "11.4",
      "poi_walking_minutes": "4 hours 19 mins",
      "poi_biking_minutes": "1 hour 28 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 980-701-0450",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-5aea-77ff-9d7f-abf99a1c4612.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-5aea-77ff-9d7f-abf99a1c4612",
        "storage_key": "property/6767906449167014/019d02d5-5aea-77ff-9d7f-abf99a1c4612.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJiWWWOZUfVIgRRfVwufBjA88",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_47ecfdb3-6ff7-47fb-b396-e6bdb67d0bd3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "University City Paddle Boats",
      "poi_type": "Entertainment",
      "poi_address": "9005 J M Keynes Dr, Charlotte, NC 28262, USA",
      "poi_short_description": "Rental location featuring paddleboats for 2–4 people, as well as life jackets and clean boats.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-1318-7558-ac3c-88bf55ab9a86.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-1318-7558-ac3c-88bf55ab9a86",
        "storage_key": "property/6767906449167014/019d02d5-1318-7558-ac3c-88bf55ab9a86.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.universitycitypaddleboats.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7351029359057933475&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-city-paddle-boats",
      "poi_latitude": "35.3103962",
      "poi_longitude": "-80.7497052",
      "poi_miles_from_property": "12.9",
      "poi_walking_minutes": "4 hours 49 mins",
      "poi_biking_minutes": "1 hour 32 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 704-237-0611",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-5ae4-7266-843e-aae0738d7e07.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-5ae4-7266-843e-aae0738d7e07",
        "storage_key": "property/6767906449167014/019d02d5-5ae4-7266-843e-aae0738d7e07.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUfdnUDscVIgRo5QdMEEaBGY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a8c6c541-cedc-42d1-93a2-b9ebbe0c5cee",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "U.S. National Whitewater Center",
      "poi_type": "Entertainment",
      "poi_address": "5000 Whitewater Center Pkwy, Charlotte, NC 28214, USA",
      "poi_short_description": "Recreation grounds with whitewater rafting, canoeing, kayaking, rappelling, rock climbing & more.",
      "poi_long_description": "Recreation grounds with whitewater rafting, canoeing, kayaking, rappelling, rock climbing & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-1554-72f8-bd84-29cf648e36c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-1554-72f8-bd84-29cf648e36c3",
        "storage_key": "property/6767906449167014/019d02d5-1554-72f8-bd84-29cf648e36c3.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.whitewater.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11500212967885119010&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "us-national-whitewater-center",
      "poi_latitude": "35.2712966",
      "poi_longitude": "-81.00554029999999",
      "poi_miles_from_property": "19.6",
      "poi_walking_minutes": "7 hours 19 mins",
      "poi_biking_minutes": "1 hour 50 mins",
      "poi_driving_minutes": "32 mins",
      "poi_business_phone": "+1 704-391-3900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-6599-7772-afdf-47b7293a5073.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-6599-7772-afdf-47b7293a5073",
        "storage_key": "property/6767906449167014/019d02d5-6599-7772-afdf-47b7293a5073.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJvd734yC9VogRIh4ieMP2mJ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_aa67d12a-b166-4d79-8762-7662e9cc9a23",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "Charlotte Motor Speedway",
      "poi_type": "Entertainment",
      "poi_address": "5555 Concord Pkwy S, Concord, NC 28027, USA",
      "poi_short_description": "Iconic NASCAR racetrack in a 95,000-seat stadium, with separate drag-racing & dirt tracks.",
      "poi_long_description": "Iconic NASCAR racetrack in a 95,000-seat stadium, with separate drag-racing & dirt tracks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-14f9-7499-b16f-11b0b2844fd1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-14f9-7499-b16f-11b0b2844fd1",
        "storage_key": "property/6767906449167014/019d02d5-14f9-7499-b16f-11b0b2844fd1.webp",
        "width": 800,
        "height": 476
      },
      "poi_business_url": "https://www.charlottemotorspeedway.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3877864903075356639&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "charlotte-motor-speedway",
      "poi_latitude": "35.3516041",
      "poi_longitude": "-80.686624",
      "poi_miles_from_property": "20",
      "poi_walking_minutes": "7 hours 23 mins",
      "poi_biking_minutes": "1 hour 52 mins",
      "poi_driving_minutes": "37 mins",
      "poi_business_phone": "+1 800-455-3267",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-5ae4-7266-843e-aae0738d7e07.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-5ae4-7266-843e-aae0738d7e07",
        "storage_key": "property/6767906449167014/019d02d5-5ae4-7266-843e-aae0738d7e07.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi8sDiRsbVIgR39_CYpXx0DU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_0429503d-bdf5-43cc-aea5-6d23f6cf9513",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "Discovery Place Science",
      "poi_type": "Entertainment",
      "poi_address": "168 W 6th St, Charlotte, NC 28202, USA",
      "poi_short_description": "Kids' science & tech museum with interactive exhibits, an aquarium, rain forest & IMAX theater.",
      "poi_long_description": "Kids' science & tech museum with interactive exhibits, an aquarium, rain forest & IMAX theater.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-1771-722a-8e4e-2c951c5d9b84.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-1771-722a-8e4e-2c951c5d9b84",
        "storage_key": "property/6767906449167014/019d02d5-1771-722a-8e4e-2c951c5d9b84.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "http://discoveryplace.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8672994214166199027&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "discovery-place-science",
      "poi_latitude": "35.229441",
      "poi_longitude": "-80.8409271",
      "poi_miles_from_property": "8.3",
      "poi_walking_minutes": "3 hours 8 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 704-327-2189",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-659f-72cf-beeb-1a2a9623adbb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-659f-72cf-beeb-1a2a9623adbb",
        "storage_key": "property/6767906449167014/019d02d5-659f-72cf-beeb-1a2a9623adbb.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ-LB1SSgVogR8_pkSkmqXHg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_3a942bf0-8b47-4a0d-a5c5-0ac6d4f7e6cd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "Novant Health Matthews Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1500 Matthews Township Pkwy, Matthews, NC 28105, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-1ba8-7648-92b7-474f3e5b7ffd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-1ba8-7648-92b7-474f3e5b7ffd",
        "storage_key": "property/6767906449167014/019d02d5-1ba8-7648-92b7-474f3e5b7ffd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.novanthealth.org/locations/medical-centers/matthews-medical-center/?utm_source=maps.google.com&utm_medium=organic&utm_campaign=GBP&utm_content=MC-08",
      "poi_directions_map_url": "https://maps.google.com/?cid=762227437680560030&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "novant-health-matthews-medical-center",
      "poi_latitude": "35.1197848",
      "poi_longitude": "-80.71463899999999",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 704-384-6500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-65c0-755f-9638-f5d0c03024ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-65c0-755f-9638-f5d0c03024ef",
        "storage_key": "property/6767906449167014/019d02d5-65c0-755f-9638-f5d0c03024ef.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJO8c8EgckVIgRnocB7dD5kwo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_5ae5c084-18e1-4e40-b1e0-6544eb01b6ee",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "Novant Health-GoHealth Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "9600 E Independence Blvd STE B, Matthews, NC 28105, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-1bba-740e-8c2a-dd89e9e7116a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-1bba-740e-8c2a-dd89e9e7116a",
        "storage_key": "property/6767906449167014/019d02d5-1bba-740e-8c2a-dd89e9e7116a.webp",
        "width": 685,
        "height": 678
      },
      "poi_business_url": "https://www.gohealthuc.com/novant/locations/matthews?utm_source=gmb&utm_medium=organic&utm_content=novant-matthews",
      "poi_directions_map_url": "https://maps.google.com/?cid=15216903225461090546&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "novant-health-gohealth-urgent-care",
      "poi_latitude": "35.1355195",
      "poi_longitude": "-80.7151772",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 704-815-5624",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-5ae4-7266-843e-aae0738d7e07.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-5ae4-7266-843e-aae0738d7e07",
        "storage_key": "property/6767906449167014/019d02d5-5ae4-7266-843e-aae0738d7e07.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbd_urgQjVIgR8qgaZ9xMLdM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_ea6cfe26-b3a1-4532-8a3a-dec600916c6f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "OrthoCarolina Urgent Care Matthews",
      "poi_type": "Health and Wellness",
      "poi_address": "710 Park Center Dr, Matthews, NC 28105, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-1d62-762d-ac24-d5a3f9d102bc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-1d62-762d-ac24-d5a3f9d102bc",
        "storage_key": "property/6767906449167014/019d02d5-1d62-762d-ac24-d5a3f9d102bc.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.orthocarolina.com/locations/matthews-urgent-care?utm_source=GMBSocialClimb&utm_medium=OrthoCarolinaUrgentCareMatthews",
      "poi_directions_map_url": "https://maps.google.com/?cid=7847689591959203331&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orthocarolina-urgent-care-matthews",
      "poi_latitude": "35.121742",
      "poi_longitude": "-80.721659",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 704-323-3215",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-5ae4-7266-843e-aae0738d7e07.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-5ae4-7266-843e-aae0738d7e07",
        "storage_key": "property/6767906449167014/019d02d5-5ae4-7266-843e-aae0738d7e07.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJocYrQAAkVIgRAy5C5BqY6Gw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_54724e34-fe13-4d24-a1e6-a8dca1a9360e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "MinuteClinic at CVS",
      "poi_type": "Health and Wellness",
      "poi_address": "1305 Matthews Township Pkwy, Matthews, NC 28105, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-2014-75ac-8123-a33fe23ea3d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-2014-75ac-8123-a33fe23ea3d7",
        "storage_key": "property/6767906449167014/019d02d5-2014-75ac-8123-a33fe23ea3d7.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.cvs.com/minuteclinic/clinic-locator/nc/matthews/4299.html?WT.mc_id=LS_mc_google_carenav_4299",
      "poi_directions_map_url": "https://maps.google.com/?cid=354730548551254091&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "minuteclinic-at-cvs",
      "poi_latitude": "35.1224296",
      "poi_longitude": "-80.7168073",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 866-389-2727",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-5ae4-7266-843e-aae0738d7e07.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-5ae4-7266-843e-aae0738d7e07",
        "storage_key": "property/6767906449167014/019d02d5-5ae4-7266-843e-aae0738d7e07.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi3aDW_8jVIgRS4Bg8Y1B7AQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_f8440324-526e-4982-87cc-87e8610e3b80",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "1220 Matthews Township Pkwy, Matthews, NC 28105, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-233a-72cd-bc4c-5aa3c8ada75e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-233a-72cd-bc4c-5aa3c8ada75e",
        "storage_key": "property/6767906449167014/019d02d5-233a-72cd-bc4c-5aa3c8ada75e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-1220+matthews+township+pkwy-matthews-nc-28105/id=6479",
      "poi_directions_map_url": "https://maps.google.com/?cid=15030130821009637248&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "35.1214004",
      "poi_longitude": "-80.7183575",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 704-814-9487",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-5ae4-7266-843e-aae0738d7e07.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-5ae4-7266-843e-aae0738d7e07",
        "storage_key": "property/6767906449167014/019d02d5-5ae4-7266-843e-aae0738d7e07.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnwFIjwAkVIgRgP_tQVnAldA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_9e8e3a54-0ed9-4c91-8e39-b021c850f436",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "Brace Family YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "3127 Weddington Rd, Matthews, NC 28105, USA",
      "poi_short_description": "Membership-based chain of fitness centers boasting a pool, track and clean gym equipment.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-2347-739d-bd6c-c29f397a962a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-2347-739d-bd6c-c29f397a962a",
        "storage_key": "property/6767906449167014/019d02d5-2347-739d-bd6c-c29f397a962a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ymcacharlotte.org/locations/brace-family-ymca",
      "poi_directions_map_url": "https://maps.google.com/?cid=15006674512564932119&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brace-family-ymca",
      "poi_latitude": "35.084674",
      "poi_longitude": "-80.7298424",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "3 hours 0 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 704-716-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-5ae4-7266-843e-aae0738d7e07.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-5ae4-7266-843e-aae0738d7e07",
        "storage_key": "property/6767906449167014/019d02d5-5ae4-7266-843e-aae0738d7e07.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtTx3f4YmVIgRF05X3fVqQtA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_d0ff767c-2846-4c59-9922-88a54d67f0c9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "Club Pilates",
      "poi_type": "Health and Wellness",
      "poi_address": "2211 Matthews Township Pkwy E, Matthews, NC 28105, USA",
      "poi_short_description": "Studio chain offering group and private Pilates classes with reformers and other equipment.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-2453-70bd-9a55-1b8cf47d4b30.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-2453-70bd-9a55-1b8cf47d4b30",
        "storage_key": "property/6767906449167014/019d02d5-2453-70bd-9a55-1b8cf47d4b30.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.clubpilates.com/matthews/?utm_source=google.com&utm_medium=referral&utm_campaign=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=14835767600875873601&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "club-pilates",
      "poi_latitude": "35.1287646",
      "poi_longitude": "-80.70299829999999",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 704-594-5670",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-6063-705d-9c21-11a04a8ebb76.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-6063-705d-9c21-11a04a8ebb76",
        "storage_key": "property/6767906449167014/019d02d5-6063-705d-9c21-11a04a8ebb76.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJifnEtvMjVIgRQaV0nAc8480",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_079aa134-0405-49fd-a73c-cc7224b859d8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "10052 E Independence Blvd, Matthews, NC 28105, USA",
      "poi_short_description": "Chain fitness center offering a variety of cardio and weight machines, plus tanning beds, and massage chairs.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-2878-71c0-87ab-65c9050b6c01.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-2878-71c0-87ab-65c9050b6c01",
        "storage_key": "property/6767906449167014/019d02d5-2878-71c0-87ab-65c9050b6c01.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/charlotte-matthews-nc?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=930328683963538832&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "35.13055",
      "poi_longitude": "-80.71171269999999",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 980-339-5257",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-5ae4-7266-843e-aae0738d7e07.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-5ae4-7266-843e-aae0738d7e07",
        "storage_key": "property/6767906449167014/019d02d5-5ae4-7266-843e-aae0738d7e07.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrVtX11whVIgRkN0ATAIx6Qw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_c6b50add-ac7e-48fc-a611-d5421e0c21ad",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "Perfect Balance Training Center",
      "poi_type": "Health and Wellness",
      "poi_address": "8850 Monroe Rd, Charlotte, NC 28212, USA",
      "poi_short_description": "Child-friendly facility for competitive gymnastics classes and team training for all ages.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-2a68-759a-8975-f81a77cd36f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-2a68-759a-8975-f81a77cd36f8",
        "storage_key": "property/6767906449167014/019d02d5-2a68-759a-8975-f81a77cd36f8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://perfectbalancecharlotte.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1402009916853711957&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "perfect-balance-training-center",
      "poi_latitude": "35.1494583",
      "poi_longitude": "-80.7465928",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 980-299-8445",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-6063-705d-9c21-11a04a8ebb76.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-6063-705d-9c21-11a04a8ebb76",
        "storage_key": "property/6767906449167014/019d02d5-6063-705d-9c21-11a04a8ebb76.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ4YbJHBUhVIgRVfSjWZfwdBM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_11c7aff8-7232-4d85-b46d-2b79891c608d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1813 Matthews Township Pkwy suite b, Matthews, NC 28105, USA",
      "poi_short_description": "Chain fitness studio offering full-body workout programs combining cardio and strength training with real-time tracking.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-2d4c-7260-836d-2ba6f7bdba92.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-2d4c-7260-836d-2ba6f7bdba92",
        "storage_key": "property/6767906449167014/019d02d5-2d4c-7260-836d-2ba6f7bdba92.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/matthews-north-carolina-1535?utm_medium=seo&utm_source=gg&utm_term=corporate&utm_campaign=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=12877967355549069479&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "35.1252654",
      "poi_longitude": "-80.7097584",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 980-920-8151",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-5ae4-7266-843e-aae0738d7e07.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-5ae4-7266-843e-aae0738d7e07",
        "storage_key": "property/6767906449167014/019d02d5-5ae4-7266-843e-aae0738d7e07.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmZ6mtvAjVIgRpzCUWBS7t7I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_565fff54-31d5-4ae6-a637-6d7a145a517f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "McAlpine Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8711 Monroe Rd, Charlotte, NC 28212, USA",
      "poi_short_description": "114-acre county park with a lake & fishing pier, soccer fields, hiking & bike trails, & a dog park.",
      "poi_long_description": "114-acre county park with a lake & fishing pier, soccer fields, hiking & bike trails, & a dog park.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-0c75-7352-942d-94fcd38cd22f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-0c75-7352-942d-94fcd38cd22f",
        "storage_key": "property/6767906449167014/019d02d5-0c75-7352-942d-94fcd38cd22f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.charlottesgotalot.com/things-to-do/outdoors-adventure/mcalpine-creek-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=16208764795226960044&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mcalpine-creek-park",
      "poi_latitude": "35.1499816",
      "poi_longitude": "-80.7409267",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 704-552-8213",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-6599-7772-afdf-47b7293a5073.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-6599-7772-afdf-47b7293a5073",
        "storage_key": "property/6767906449167014/019d02d5-6599-7772-afdf-47b7293a5073.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJYZHiVRMhVIgRrDBcG7QZ8eA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c016a3cb-336b-4343-92e8-06579f8148b5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "McAlpine Creek Greenway Trailhead",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "110 Old Bell Rd, Charlotte, NC 28270, USA",
      "poi_short_description": "Popular paved greenway with a pond, picnic area, restrooms, and dog park, plus wildlife sightings.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-2f1d-7055-bc66-c973e04797ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-2f1d-7055-bc66-c973e04797ff",
        "storage_key": "property/6767906449167014/019d02d5-2f1d-7055-bc66-c973e04797ff.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1957761888640240409&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mcalpine-creek-greenway-trailhead",
      "poi_latitude": "35.136245",
      "poi_longitude": "-80.7674631",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-6599-7772-afdf-47b7293a5073.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-6599-7772-afdf-47b7293a5073",
        "storage_key": "property/6767906449167014/019d02d5-6599-7772-afdf-47b7293a5073.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ09KJ4JQhVIgRGQszpxBeKxs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_57da1929-09e4-403d-a4f3-8c49036b971c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "Campbell Creek Greenway Trailhead",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2116 Margaret Wallace Rd, Matthews, NC 28105, USA",
      "poi_short_description": "Wooded, wheelchair-accessible trail with a babbling stream that's great for hiking, running and biking.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-30af-7679-a79b-00efcffa9e2e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-30af-7679-a79b-00efcffa9e2e",
        "storage_key": "property/6767906449167014/019d02d5-30af-7679-a79b-00efcffa9e2e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14732149793175370742&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "campbell-creek-greenway-trailhead",
      "poi_latitude": "35.1639956",
      "poi_longitude": "-80.7376049",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-6599-7772-afdf-47b7293a5073.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-6599-7772-afdf-47b7293a5073",
        "storage_key": "property/6767906449167014/019d02d5-6599-7772-afdf-47b7293a5073.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJD9HynJ4hVIgR9vsPwC4cc8w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_93e79c9d-d775-4662-ae8a-140dce893150",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "Mason Wallace Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7301 Monroe Rd, Charlotte, NC 28212, USA",
      "poi_short_description": "Recreational area with soccer, basketball, and tennis courts, plus a playground and picnic areas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-3244-74a8-826d-56f60c63c78c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-3244-74a8-826d-56f60c63c78c",
        "storage_key": "property/6767906449167014/019d02d5-3244-74a8-826d-56f60c63c78c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mecknc.gov/ParkandRec/Parks/ParksByRegion/SouthRegion/Pages/MasonWallace.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=3505565514726496140&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mason-wallace-park",
      "poi_latitude": "35.1695856",
      "poi_longitude": "-80.7523975",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 704-643-5725",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-6599-7772-afdf-47b7293a5073.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-6599-7772-afdf-47b7293a5073",
        "storage_key": "property/6767906449167014/019d02d5-6599-7772-afdf-47b7293a5073.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1fsDoqchVIgRjNchKkNFpjA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_bb8f5196-68c6-44a4-948e-4c1c4696935b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "McAlpine Creek Dog Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8617 Monroe Rd, Charlotte, NC 28212, USA",
      "poi_short_description": "Huge park split into areas for small dogs and large dogs.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-34c6-775f-a52f-ed691843f8f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-34c6-775f-a52f-ed691843f8f4",
        "storage_key": "property/6767906449167014/019d02d5-34c6-775f-a52f-ed691843f8f4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=151022794777038150&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mcalpine-creek-dog-park",
      "poi_latitude": "35.1523827",
      "poi_longitude": "-80.74368500000001",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-6599-7772-afdf-47b7293a5073.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-6599-7772-afdf-47b7293a5073",
        "storage_key": "property/6767906449167014/019d02d5-6599-7772-afdf-47b7293a5073.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJB55cQGchVIgRRg2sg26KGAI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "custom_c044f4d6-0b25-43c9-a9e8-384e5a9de23b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "James Boyce Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "300 Boyce Rd, Charlotte, NC 28211, USA",
      "poi_short_description": "Sizable park with a playground & fields for softball & soccer, plus wooded trails & picnic areas.",
      "poi_long_description": "Sizable park with a playground & fields for softball & soccer, plus wooded trails & picnic areas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-3846-747f-9254-3b96356108b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-3846-747f-9254-3b96356108b4",
        "storage_key": "property/6767906449167014/019d02d5-3846-747f-9254-3b96356108b4.webp",
        "width": 1280,
        "height": 812
      },
      "poi_business_url": "https://www.mecknc.gov/parkandrec/parks/parksbyregion/southregion/pages/james.aspx?redirect=charmeck",
      "poi_directions_map_url": "https://maps.google.com/?cid=8124777098431291788&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "james-boyce-park",
      "poi_latitude": "35.1449791",
      "poi_longitude": "-80.76607589999999",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 704-643-5725",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-6599-7772-afdf-47b7293a5073.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-6599-7772-afdf-47b7293a5073",
        "storage_key": "property/6767906449167014/019d02d5-6599-7772-afdf-47b7293a5073.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJndv5e98gVIgRjOE5X7kBwXA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_5820568d-1ee4-42a7-97a4-3d3a039f5881",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "Squirrel Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1631 Pleasant Plains Rd, Matthews, NC 28105, USA",
      "poi_short_description": "Recreation area with a playground, charcoal grills, picnic tables, fishing piers & restrooms.",
      "poi_long_description": "Recreation area with a playground, charcoal grills, picnic tables, fishing piers & restrooms.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-3a9a-776e-8566-e100ca0e1def.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-3a9a-776e-8566-e100ca0e1def",
        "storage_key": "property/6767906449167014/019d02d5-3a9a-776e-8566-e100ca0e1def.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.matthewsnc.gov/facilityview.aspx?fid=46",
      "poi_directions_map_url": "https://maps.google.com/?cid=12272761902962772969&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "squirrel-lake-park",
      "poi_latitude": "35.0997222",
      "poi_longitude": "-80.7230556",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 704-708-1260",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-6599-7772-afdf-47b7293a5073.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-6599-7772-afdf-47b7293a5073",
        "storage_key": "property/6767906449167014/019d02d5-6599-7772-afdf-47b7293a5073.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJWaMklJ8mVIgR6QsLR-2bUao",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_4021557b-51fc-486f-bdcd-c16922907ca6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "Purser-Hulsey Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "13201 Phillips Rd, Matthews, NC 28105, USA",
      "poi_short_description": "Hiking and biking trails featuring an enchanted forest area, plus a dog run.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-3ada-742e-9b34-b51fd02e20b6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-3ada-742e-9b34-b51fd02e20b6",
        "storage_key": "property/6767906449167014/019d02d5-3ada-742e-9b34-b51fd02e20b6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.matthewsnc.gov/facilityview.aspx?fid=54",
      "poi_directions_map_url": "https://maps.google.com/?cid=10623819329325785469&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "purser-hulsey-park",
      "poi_latitude": "35.1294326",
      "poi_longitude": "-80.6834348",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 704-321-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-6599-7772-afdf-47b7293a5073.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-6599-7772-afdf-47b7293a5073",
        "storage_key": "property/6767906449167014/019d02d5-6599-7772-afdf-47b7293a5073.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJAXQD7oQjVIgRfWFkgmRjb5M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_deb34f62-74c3-44c1-bca9-80dc81120636",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "Reedy Creek Nature Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2986 ROCKY RIVER RD, Charlotte, NC 28215, USA",
      "poi_short_description": "Nature center with animals & a gift shop in a 927-acre preserve with fishing, hiking & more.",
      "poi_long_description": "Nature center with animals & a gift shop in a 927-acre preserve with fishing, hiking & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-3ceb-71dd-a120-0770fa188f17.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-3ceb-71dd-a120-0770fa188f17",
        "storage_key": "property/6767906449167014/019d02d5-3ceb-71dd-a120-0770fa188f17.webp",
        "width": 1280,
        "height": 958
      },
      "poi_business_url": "https://parkandrec.mecknc.gov/Places-to-Visit/Nature/reedy-creek-nature-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=3576989697573525763&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "reedy-creek-nature-center",
      "poi_latitude": "35.261767",
      "poi_longitude": "-80.71938000000002",
      "poi_miles_from_property": "10.4",
      "poi_walking_minutes": "3 hours 52 mins",
      "poi_biking_minutes": "1 hour 14 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 980-314-1119",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-6599-7772-afdf-47b7293a5073.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-6599-7772-afdf-47b7293a5073",
        "storage_key": "property/6767906449167014/019d02d5-6599-7772-afdf-47b7293a5073.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJRRFBPi0ZVIgRAxkaoS0FpDE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_5f0c3c5d-8f58-43be-9262-37a9173c4a2d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "Mason-Wallace Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "7300 Monroe Rd, Charlotte, NC 28212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-3f97-71b8-a5ba-506efd7aee2d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-3f97-71b8-a5ba-506efd7aee2d",
        "storage_key": "property/6767906449167014/019d02d5-3f97-71b8-a5ba-506efd7aee2d.webp",
        "width": 1280,
        "height": 866
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5342287091657864418&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mason-wallace-park--ride",
      "poi_latitude": "35.1686137",
      "poi_longitude": "-80.7555316",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-6621-72a8-9b16-01972784ca54.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-6621-72a8-9b16-01972784ca54",
        "storage_key": "property/6767906449167014/019d02d5-6621-72a8-9b16-01972784ca54.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJZXypIKghVIgR4vRrIs6dI0o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_0cc18e4e-4dcb-494c-ad70-d1e8ea8b5cae",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "Cokesbury United Methodist Congregation",
      "poi_type": "Transportation & Transit",
      "poi_address": "6701 Idlewild Rd, Charlotte, NC 28212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-4220-74eb-8992-3b5319002d0e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-4220-74eb-8992-3b5319002d0e",
        "storage_key": "property/6767906449167014/019d02d5-4220-74eb-8992-3b5319002d0e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.umc.org/find-a-church/church?id=32412",
      "poi_directions_map_url": "https://maps.google.com/?cid=15934141741176306175&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cokesbury-united-methodist-congregation",
      "poi_latitude": "35.1857448",
      "poi_longitude": "-80.7498299",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 704-537-5818",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-6ac6-709a-a5ee-68494608f44b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-6ac6-709a-a5ee-68494608f44b",
        "storage_key": "property/6767906449167014/019d02d5-6ac6-709a-a5ee-68494608f44b.webp",
        "width": 144,
        "height": 192
      },
      "poi_google_place_id": "ChIJk5ffR7khVIgR_7mJq31xId0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "church"
    },
    {
      "id": "custom_18a23821-97bd-4246-9f73-f717240141c5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "St John Neumann Catholic Church",
      "poi_type": "Transportation & Transit",
      "poi_address": "8451 Idlewild Rd, Charlotte, NC 28227, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-427d-725d-b045-eab1622b1e31.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-427d-725d-b045-eab1622b1e31",
        "storage_key": "property/6767906449167014/019d02d5-427d-725d-b045-eab1622b1e31.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://4sjnc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13043554926473521523&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-john-neumann-catholic-church",
      "poi_latitude": "35.1805449",
      "poi_longitude": "-80.72407989999999",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 704-536-6520",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-6ac6-709a-a5ee-68494608f44b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-6ac6-709a-a5ee-68494608f44b",
        "storage_key": "property/6767906449167014/019d02d5-6ac6-709a-a5ee-68494608f44b.webp",
        "width": 144,
        "height": 192
      },
      "poi_google_place_id": "ChIJvcX7pokhVIgRcynAEBkEBLU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "church"
    },
    {
      "id": "custom_e43d3c9f-5727-41bf-b71d-a388b7d695a9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "Riverbend Park and Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Charlotte, NC 28216, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8842128954005509861&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "riverbend-park-and-ride",
      "poi_latitude": "35.32882",
      "poi_longitude": "-80.94192",
      "poi_miles_from_property": "19.3",
      "poi_walking_minutes": "7 hours 13 mins",
      "poi_biking_minutes": "1 hour 44 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-5ae4-7266-843e-aae0738d7e07.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-5ae4-7266-843e-aae0738d7e07",
        "storage_key": "property/6767906449167014/019d02d5-5ae4-7266-843e-aae0738d7e07.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKf5NEWKkVogR5daxoW-NtXo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_cfbe36d1-dbab-44d9-add2-116ec92dc4c5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "Northlake Mall Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Charlotte, NC 28216, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11574504833305702147&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northlake-mall-park--ride",
      "poi_latitude": "35.352833",
      "poi_longitude": "-80.85521899999999",
      "poi_miles_from_property": "17.9",
      "poi_walking_minutes": "6 hours 43 mins",
      "poi_biking_minutes": "1 hour 40 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-5ae4-7266-843e-aae0738d7e07.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-5ae4-7266-843e-aae0738d7e07",
        "storage_key": "property/6767906449167014/019d02d5-5ae4-7266-843e-aae0738d7e07.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVfdxJlWmVogRA286UNLmoKA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_f9db5b47-3036-459c-87e9-756cdbb2b260",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "Charlotte Transportation Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "310 E Trade St, Charlotte, NC 28202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4144275419840309105&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "charlotte-transportation-center",
      "poi_latitude": "35.2246882",
      "poi_longitude": "-80.8406333",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-5ae4-7266-843e-aae0738d7e07.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-5ae4-7266-843e-aae0738d7e07",
        "storage_key": "property/6767906449167014/019d02d5-5ae4-7266-843e-aae0738d7e07.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN63efwChVogRcef2eolsgzk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_872eed85-854b-4934-b7ea-5042baa94ab7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "Charlotte",
      "poi_type": "Transportation & Transit",
      "poi_address": "1914 N Tryon St, Charlotte, NC 28206, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-43f0-7630-b5c4-f3ed25d3a0f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-43f0-7630-b5c4-f3ed25d3a0f2",
        "storage_key": "property/6767906449167014/019d02d5-43f0-7630-b5c4-f3ed25d3a0f2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=CLT",
      "poi_directions_map_url": "https://maps.google.com/?cid=9204761905035767858&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "charlotte",
      "poi_latitude": "35.241285",
      "poi_longitude": "-80.82270799999999",
      "poi_miles_from_property": "9.4",
      "poi_walking_minutes": "3 hours 32 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-5ae4-7266-843e-aae0738d7e07.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-5ae4-7266-843e-aae0738d7e07",
        "storage_key": "property/6767906449167014/019d02d5-5ae4-7266-843e-aae0738d7e07.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyS4qEG2gVogRMnC0By_ivX8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_station"
    },
    {
      "id": "custom_84e93d5f-c901-4ede-9446-ccbbd7835443",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "Charlotte Douglas International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "5501 Josh Birmingham Pkwy, Charlotte, NC 28208, USA",
      "poi_short_description": "Airport with rocking chairs, free WiFi & a 60-foot outdoor sculpture symbolizing flight.",
      "poi_long_description": "Airport with rocking chairs, free WiFi & a 60-foot outdoor sculpture symbolizing flight.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-46fd-75f1-865f-27cfe3512cbb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-46fd-75f1-865f-27cfe3512cbb",
        "storage_key": "property/6767906449167014/019d02d5-46fd-75f1-865f-27cfe3512cbb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cltairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1925933632275654455&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "charlotte-douglas-international-airport",
      "poi_latitude": "35.2162994",
      "poi_longitude": "-80.95394280000001",
      "poi_miles_from_property": "16.6",
      "poi_walking_minutes": "6 hours 9 mins",
      "poi_biking_minutes": "1 hour 38 mins",
      "poi_driving_minutes": "31 mins",
      "poi_business_phone": "+1 704-359-4013",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-6b43-7061-ba9e-b5f397baca2f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-6b43-7061-ba9e-b5f397baca2f",
        "storage_key": "property/6767906449167014/019d02d5-6b43-7061-ba9e-b5f397baca2f.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJidRKt32YVogRN6fEPG9Kuho",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_d0830b8a-af58-4885-b6b3-ec054b1fda78",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "Ballantyne Corporate Park",
      "poi_type": "Major Employers & Offices",
      "poi_address": "13024 Ballantyne Corporate Pl, Charlotte, NC 28277, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-4a0c-70a1-8817-5a32082618be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-4a0c-70a1-8817-5a32082618be",
        "storage_key": "property/6767906449167014/019d02d5-4a0c-70a1-8817-5a32082618be.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11291628300610551353&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ballantyne-corporate-park",
      "poi_latitude": "35.0559701",
      "poi_longitude": "-80.84288769999999",
      "poi_miles_from_property": "11.6",
      "poi_walking_minutes": "4 hours 13 mins",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-5ae4-7266-843e-aae0738d7e07.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-5ae4-7266-843e-aae0738d7e07",
        "storage_key": "property/6767906449167014/019d02d5-5ae4-7266-843e-aae0738d7e07.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXfMErjqdVogROb6jIR3ss5w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_54701b5a-ccee-427e-8cb4-c246113d0eaa",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "Dentsply Sirona",
      "poi_type": "Major Employers & Offices",
      "poi_address": "13320 Ballantyne Corporate Pl, Charlotte, NC 28277, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-49e1-72db-8a17-62bfb5dfe36c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-49e1-72db-8a17-62bfb5dfe36c",
        "storage_key": "property/6767906449167014/019d02d5-49e1-72db-8a17-62bfb5dfe36c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.dentsplysirona.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4624131679668005985&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dentsply-sirona",
      "poi_latitude": "35.0606841",
      "poi_longitude": "-80.8460801",
      "poi_miles_from_property": "11.4",
      "poi_walking_minutes": "4 hours 8 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 704-587-0453",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-6056-75bc-9de9-fc3630936a83.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-6056-75bc-9de9-fc3630936a83",
        "storage_key": "property/6767906449167014/019d02d5-6056-75bc-9de9-fc3630936a83.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJQT6ZhqeZVogRYew9UUM3LEA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_bcdcd826-ab47-4057-8256-ad7e6613591b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "Premier, Inc.",
      "poi_type": "Major Employers & Offices",
      "poi_address": "13520 Ballantyne Corporate Pl, Charlotte, NC 28277, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-4b12-70f6-b489-750234f079db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-4b12-70f6-b489-750234f079db",
        "storage_key": "property/6767906449167014/019d02d5-4b12-70f6-b489-750234f079db.webp",
        "width": 754,
        "height": 960
      },
      "poi_business_url": "http://www.premierinc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11599173814418190887&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "premier-inc",
      "poi_latitude": "35.0623151",
      "poi_longitude": "-80.85028059999999",
      "poi_miles_from_property": "11.6",
      "poi_walking_minutes": "4 hours 13 mins",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 704-357-0022",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-5ae4-7266-843e-aae0738d7e07.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-5ae4-7266-843e-aae0738d7e07",
        "storage_key": "property/6767906449167014/019d02d5-5ae4-7266-843e-aae0738d7e07.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3SHgScGYVogRJ7JoECGL-KA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_17c744d1-4f93-4427-bc2d-2d982693ad8a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "SPX FLOW",
      "poi_type": "Major Employers & Offices",
      "poi_address": "13320 Ballantyne Corporate Pl, Charlotte, NC 28277, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-4e2f-73bb-adec-8a5bf387c8a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-4e2f-73bb-adec-8a5bf387c8a5",
        "storage_key": "property/6767906449167014/019d02d5-4e2f-73bb-adec-8a5bf387c8a5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.spxflow.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=126902119518994745&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "spx-flow",
      "poi_latitude": "35.0607938",
      "poi_longitude": "-80.8458228",
      "poi_miles_from_property": "11.4",
      "poi_walking_minutes": "4 hours 9 mins",
      "poi_biking_minutes": "1 hour 6 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 704-752-4400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-5ae4-7266-843e-aae0738d7e07.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-5ae4-7266-843e-aae0738d7e07",
        "storage_key": "property/6767906449167014/019d02d5-5ae4-7266-843e-aae0738d7e07.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ__-_gSSdVogROYEsK87YwgE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_ab1110e2-a744-41ba-bf38-8099dd3e7c7f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "Brighthouse Financial",
      "poi_type": "Major Employers & Offices",
      "poi_address": "11225 N Community House Rd, Charlotte, NC 28277, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-50a3-7412-9ae8-3c77577d9a5d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-50a3-7412-9ae8-3c77577d9a5d",
        "storage_key": "property/6767906449167014/019d02d5-50a3-7412-9ae8-3c77577d9a5d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.brighthousefinancial.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18051800898087324256&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brighthouse-financial",
      "poi_latitude": "35.0555585",
      "poi_longitude": "-80.8372897",
      "poi_miles_from_property": "11.4",
      "poi_walking_minutes": "4 hours 10 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 800-882-1292",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-5ae4-7266-843e-aae0738d7e07.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-5ae4-7266-843e-aae0738d7e07",
        "storage_key": "property/6767906449167014/019d02d5-5ae4-7266-843e-aae0738d7e07.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_4X28DmdVogRYIqSNkbhhPo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_1b218c64-27dd-439b-bf66-e0e2a09203f7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "TIAA Financial Services",
      "poi_type": "Major Employers & Offices",
      "poi_address": "15720 Brixham Hill Avenue Suite 300, Office 346, 348 349, 381, Charlotte, NC 28277, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-50f1-71be-ae83-21f0bc48538a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-50f1-71be-ae83-21f0bc48538a",
        "storage_key": "property/6767906449167014/019d02d5-50f1-71be-ae83-21f0bc48538a.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://locations.tiaa.org/nc/charlotte/15720-brixham-hill-avenue?tc_mcid=bn_yextglocal_0618",
      "poi_directions_map_url": "https://maps.google.com/?cid=8472991454691818217&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tiaa-financial-services",
      "poi_latitude": "35.0592585",
      "poi_longitude": "-80.85215029999999",
      "poi_miles_from_property": "11.3",
      "poi_walking_minutes": "4 hours 7 mins",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 877-535-3910",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-5ae4-7266-843e-aae0738d7e07.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-5ae4-7266-843e-aae0738d7e07",
        "storage_key": "property/6767906449167014/019d02d5-5ae4-7266-843e-aae0738d7e07.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4U21T2CdVogR6XrTEdYclnU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "consultant"
    },
    {
      "id": "custom_a5352b7c-cfa7-4b92-94e6-4cc038717f79",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "RXO",
      "poi_type": "Major Employers & Offices",
      "poi_address": "11215 N Community House Rd floor 9, Charlotte, NC 28277, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://rxo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6228266398119516203&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rxo",
      "poi_latitude": "35.055108",
      "poi_longitude": "-80.8361501",
      "poi_miles_from_property": "11.3",
      "poi_walking_minutes": "4 hours 9 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 800-883-4593",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-5ae4-7266-843e-aae0738d7e07.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-5ae4-7266-843e-aae0738d7e07",
        "storage_key": "property/6767906449167014/019d02d5-5ae4-7266-843e-aae0738d7e07.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLRhV7mCdVogRK1hqUko_b1Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "courier_service"
    },
    {
      "id": "custom_f6c965e7-fdca-4ebd-b43b-4aad9456e18f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "Curtiss-Wright Corporation",
      "poi_type": "Major Employers & Offices",
      "poi_address": "13925 Ballantyne Corporate Pl, Charlotte, NC 28277, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.curtisswright.com/contact/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=240550768953896896&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "curtiss-wright-corporation",
      "poi_latitude": "35.0599853",
      "poi_longitude": "-80.85494249999999",
      "poi_miles_from_property": "11.5",
      "poi_walking_minutes": "4 hours 12 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 973-541-3700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-5ae4-7266-843e-aae0738d7e07.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-5ae4-7266-843e-aae0738d7e07",
        "storage_key": "property/6767906449167014/019d02d5-5ae4-7266-843e-aae0738d7e07.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj5KkmdicVogRwK_xXaabVgM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "consultant"
    },
    {
      "id": "custom_a0b09c95-bbe0-46bb-a9d7-f0fe43ff18f9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "Novant Health Ballantyne Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10905 Providence Rd W, Charlotte, NC 28277, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-51e3-745e-9672-b1f0b63de935.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-51e3-745e-9672-b1f0b63de935",
        "storage_key": "property/6767906449167014/019d02d5-51e3-745e-9672-b1f0b63de935.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.novanthealth.org/locations/medical-centers/ballantyne-medical-center/?utm_source=maps.google.com&utm_medium=organic&utm_campaign=GBP&utm_content=MC-23",
      "poi_directions_map_url": "https://maps.google.com/?cid=12512526997334832051&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "novant-health-ballantyne-medical-center",
      "poi_latitude": "35.0400404",
      "poi_longitude": "-80.84350100000002",
      "poi_miles_from_property": "12.5",
      "poi_walking_minutes": "4 hours 35 mins",
      "poi_biking_minutes": "1 hour 16 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 980-488-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-65c0-755f-9638-f5d0c03024ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-65c0-755f-9638-f5d0c03024ef",
        "storage_key": "property/6767906449167014/019d02d5-65c0-755f-9638-f5d0c03024ef.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJq7s--oaDVogRs7OghgJtpa0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_3a0ddb66-95ae-4852-a573-6e8b5b10d959",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "custom",
      "poi_name": "Atrium Health Pineville",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10628 Park Rd, Charlotte, NC 28210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-54f2-71d8-97ed-eaf191291763.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-54f2-71d8-97ed-eaf191291763",
        "storage_key": "property/6767906449167014/019d02d5-54f2-71d8-97ed-eaf191291763.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://atriumhealth.org/locations/detail/atrium-health-pineville?utm_source=GMB&utm_medium=Organic&utm_campaign=GCR",
      "poi_directions_map_url": "https://maps.google.com/?cid=5577615577059717873&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atrium-health-pineville",
      "poi_latitude": "35.0918492",
      "poi_longitude": "-80.8713906",
      "poi_miles_from_property": "11.4",
      "poi_walking_minutes": "4 hours 9 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 704-667-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d5-65c0-755f-9638-f5d0c03024ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d5-65c0-755f-9638-f5d0c03024ef",
        "storage_key": "property/6767906449167014/019d02d5-65c0-755f-9638-f5d0c03024ef.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJY-mdN1-cVogR8XJU3NCrZ00",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    }
  ],
  "office_hours": [
    {
      "id": "custom_dfc8fee5-73ad-48b9-96fc-850a2258f43b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_890199ba-9f2f-407c-be08-10bc6af57720",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_e851ae15-2db8-45c0-a4da-e069f3921056",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_33135576-b41b-4e7e-ba05-2942497370d2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_af059449-1435-4a77-93d1-e15e5577a3f2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_6c9afce6-b0a9-4e9c-9cda-89cf1ca8da5b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "16:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_0de9f8ed7d453561303ba8dd",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "rating": "5",
      "name": "George",
      "text": "i have never had peace, tranquility, an a Community Center that's God sent like The Park at Ferentino Apartments. Truly a blessing from God.",
      "date": "2025-11-11",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_5fc4d73b8f30f983fd621d4f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d6-a38d-7496-a4c4-76960c60924d.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Interior view of an apartment showing a small kitchen and entrance area.",
        "public_id": "019d02d6-a38d-7496-a4c4-76960c60924d",
        "storage_key": "property/6767906449167014/019d02d6-a38d-7496-a4c4-76960c60924d.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1BR,1BA - The Mallard",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=CVuQBse4sVF"
    },
    {
      "id": "ec_7e53b737f3fe7c6fada5818a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019f48de-55c7-706f-ae2b-c68ae91d9ea6.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f48de-55c7-706f-ae2b-c68ae91d9ea6",
        "storage_key": "property/6767906449167014/019f48de-55c7-706f-ae2b-c68ae91d9ea6.webp",
        "width": 800,
        "height": 449
      },
      "virtual_tour_title": "1BR, 1BA - 480 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=ho4nv4tNXnP"
    },
    {
      "id": "ec_5c452e52e0173dab7c86574a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019d02d6-a38d-7496-a4c4-70b4cab351ef.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room with a leather couch, coffee table, and fireplace.",
        "public_id": "019d02d6-a38d-7496-a4c4-70b4cab351ef",
        "storage_key": "property/6767906449167014/019d02d6-a38d-7496-a4c4-70b4cab351ef.webp",
        "width": 800,
        "height": 449
      },
      "virtual_tour_title": "1BR, 1BA - 650 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=xfmvHYR6yDg"
    },
    {
      "id": "ec_d4ade9b6825b143e8a726f4d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019f48de-5bea-728d-8b22-0b2549482ac0.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f48de-5bea-728d-8b22-0b2549482ac0",
        "storage_key": "property/6767906449167014/019f48de-5bea-728d-8b22-0b2549482ac0.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1BR, 1BA - 850SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=22fyFCiC6J7"
    },
    {
      "id": "ec_20cb4e04b589bee0589bc1fa",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167014/019f48de-5a81-7477-a151-55757eca912c.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f48de-5a81-7477-a151-55757eca912c",
        "storage_key": "property/6767906449167014/019f48de-5a81-7477-a151-55757eca912c.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 2BA - 1000SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=7i85HwMe6Wq"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019c57d7-7dbc-71db-b3b0-afbdba21cddf",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Park at Ferentino Website",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014"
    },
    {
      "lead_collector_id": "01a081bb-7adc-7460-affe-566d027396e5",
      "lead_source": "LANDING_PAGE",
      "name": "Park at Ferentino Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-charlotte-nc",
      "search_query": "pet friendly apartments charlotte nc",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in Charlotte, NC",
      "h2_subtitle": "Discover pet-friendly living in Charlotte, NC. Park at Ferentino offers welcoming spaces for you and your furry friends.",
      "page_copy": "Welcome to Park at Ferentino, where pet-friendly apartments in Charlotte, NC, meet exceptional living spaces. Our community welcomes pets, providing ample room for both you and your four-legged companions to enjoy. With amenities tailored for convenience and comfort, you'll find our spacious layouts equipped with large walk-in closets in most floorplans, perfectly suited for storing pet supplies and more.\n\nLocated in the vibrant East Forest neighborhood of Charlotte, Park at Ferentino ensures a perfect blend of city life and serene surroundings. Enjoy leisurely strolls around the community and take advantage of nearby parks with your pets. Our sparkling swimming pool and valet trash service add a touch of luxury, making this the ideal home for pet owners seeking comfort and community.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments in Charlotte, NC",
      "seo_description": "Explore pet-friendly living at Park at Ferentino in Charlotte, NC, with spacious layouts and great amenities for you and your pets.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "generator",
      "page_item_url": "sparkling-swimming-pool-apartments-east-forest",
      "search_query": "apartments with sparkling swimming pool east forest",
      "category": "Amenity",
      "h1_title": "Apartments with a Sparkling Pool in East Forest",
      "h2_subtitle": "Enjoy luxurious apartments with a sparkling swimming pool in East Forest. Park at Ferentino is your perfect home.",
      "page_copy": "At Park at Ferentino, enjoy the perfect blend of comfort and luxury with our apartments featuring a sparkling swimming pool in the heart of East Forest. Dive into relaxation as our pool provides a refreshing escape during sunny days. Located in a welcoming community in Mecklenburg County, our apartments offer spacious living, perfect for those seeking a touch of elegance in their daily routine.\n\nOur prime location in East Forest offers residents access to a thriving neighborhood with plenty of amenities right at your doorstep. Whether you're taking a dip in the pool or enjoying a workout in the fitness center complete with a yoga room, Park at Ferentino makes living effortlessly enjoyable. Discover the ideal balance of convenience and leisure right here.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Sparkling Pool in East Forest",
      "seo_description": "Find luxury living with a sparkling swimming pool at Park at Ferentino in East Forest, offering spacious apartments and premier amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-mecklenburg-county",
      "search_query": "fitness center apartments mecklenburg county",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments in Mecklenburg County",
      "h2_subtitle": "Experience premier living in Mecklenburg County with our fitness center apartments. Park at Ferentino is the ideal choice.",
      "page_copy": "Live a balanced lifestyle at Park at Ferentino, where our fitness center apartments in Mecklenburg County cater to active living aficionados. Our state-of-the-art fitness center, complete with a dedicated yoga room, ensures that you have the convenience of a full gym experience right at your doorstep. Say goodbye to crowded workout spaces and enjoy the comforts of exercise from home.\n\nSituated in the dynamic East Forest neighborhood, Park at Ferentino offers more than just fitness amenities. With features like large walk-in closets in most floorplans and a sparkling swimming pool, our community provides a well-rounded living experience. Whether you're an early bird hitting the gym before sunrise or someone who enjoys evening yoga sessions, our fitness center is ready to support your wellness journey every day.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments in Mecklenburg County",
      "seo_description": "Discover fitness-friendly living at Park at Ferentino in Mecklenburg County, featuring a gym and spacious apartments.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "generator",
      "page_item_url": "large-walk-in-closet-apartments-charlotte-28212",
      "search_query": "large walk-in closet apartments charlotte 28212",
      "category": "Amenity",
      "h1_title": "Charlotte Apartments with Large Walk-In Closets",
      "h2_subtitle": "Explore Charlotte 28212 area's spacious apartments with large walk-in closets. Park at Ferentino offers the ultimate in storage and style.",
      "page_copy": "Welcome to Park at Ferentino, the epitome of spacious living with large walk-in closets in the vibrant Charlotte 28212 area. Our thoughtfully designed apartments ensure you have ample space to organize and store your belongings with ease, making clutter-free living a reality. Whether you're a fashion enthusiast or simply need more room, our closets cater to all storage needs.\n\nNestled in East Forest, our community offers more than just generous storage solutions. Enjoy the sparkling swimming pool and valet trash service that enhance your daily life. Located conveniently in Charlotte's bustling 28212 zip code, Park at Ferentino combines ideal location, exceptional amenities, and spacious living arrangements, making it the perfect place to call home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Charlotte Apartments with Large Walk-In Closets",
      "seo_description": "Spacious living in Charlotte, 28212 at Park at Ferentino, featuring large walk-in closets and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "generator",
      "page_item_url": "apartments-with-in-unit-washer-dryer-charlotte",
      "search_query": "apartments with in unit washer dryer charlotte",
      "category": "Amenity",
      "h1_title": "Charlotte Apartments with In-Unit Washer/Dryer",
      "h2_subtitle": "Discover the convenience of in-unit washer/dryer apartments in Charlotte. Park at Ferentino offers this and more for comfortable living.",
      "page_copy": "Experience the ultimate convenience with in-unit washer/dryer apartments at Park at Ferentino, located in the vibrant city of Charlotte. Our community understands the importance of ease and efficiency in daily routines, which is why our thoughtfully designed units come equipped with these modern amenities, ensuring a hassle-free lifestyle.\n\nBeyond the convenience of laundry within the comfort of your home, Park at Ferentino offers a sparkling swimming pool and a fully-equipped fitness center with a yoga room. Situated in the East Forest neighborhood, you'll enjoy quick access to local dining, shopping, and entertainment. With its modern amenities and prime Charlotte location, our community offers more than just a place to live—it's a lifestyle.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Charlotte Apartments with In-Unit Washer/Dryer",
      "seo_description": "Find Charlotte living refined at Park at Ferentino, featuring in-unit washer/dryer and top-notch amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-charlotte-nc",
      "search_query": "one bedroom apartments charlotte nc",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Charlotte, NC",
      "h2_subtitle": "Discover one bedroom apartments in Charlotte, NC, offering modern amenities. Park at Ferentino is your new home.",
      "page_copy": "Welcome to Park at Ferentino, where our one bedroom apartments in Charlotte, NC, are designed to enhance your lifestyle. Each unit offers comfort and style with thoughtful features perfect for singles or couples. Spacious layouts and large walk-in closets ensure you have ample room to live and entertain comfortably.\n\nLocated in the vibrant East Forest neighborhood, our community provides easy access to Charlotte's rich arts, dining, and entertainment scenes. Enjoy amenities like a fitness center complete with a yoga room, a sparkling swimming pool, and valet trash service. Make Park at Ferentino your home and embrace the best of Charlotte living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Charlotte, NC",
      "seo_description": "Enjoy stylish one bedroom living in Charlotte, NC at Park at Ferentino, featuring modern amenities and spacious layouts.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-east-forest-mecklenburg",
      "search_query": "two bedroom apartments east forest mecklenburg county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in East Forest",
      "h2_subtitle": "Explore spacious two bedroom apartments in East Forest, Mecklenburg County. Park at Ferentino offers ideal living conditions.",
      "page_copy": "Discover the perfect blend of comfort and style with our two bedroom apartments at Park at Ferentino, ideally situated in East Forest, Mecklenburg County. These thoughtfully designed units offer ample space for families or roommates, complete with large walk-in closets to meet your storage needs.\n\nBeyond spacious living, our community provides a range of exceptional amenities. Dive into our sparkling swimming pool or stay active in our fitness center that includes a dedicated yoga room. Located in the thriving community of East Forest, you are minutes away from the heart of Mecklenburg County’s cultural and social life, making Park at Ferentino the perfect choice for your new home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in East Forest",
      "seo_description": "Find spacious two bedroom apartments in East Forest, Mecklenburg County at Park at Ferentino, complete with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "generator",
      "page_item_url": "apartments-near-central-piedmont-community-college",
      "search_query": "apartments near Central Piedmont Community College Charlotte",
      "category": "School",
      "h1_title": "Apartments Near Central Piedmont Community College",
      "h2_subtitle": "Find convenient apartments near Central Piedmont Community College in Charlotte at Park at Ferentino.",
      "page_copy": "Located just a short drive from Central Piedmont Community College, Park at Ferentino offers the perfect accommodations for students and faculty alike. Our prime location in Charlotte means you're close to campus while still enjoying the serene atmosphere of the East Forest neighborhood. \n\nBoasting modern amenities like a fitness center with a yoga room and a sparkling swimming pool, our community blends comfort with convenience. Each apartment features spacious designs, and many units include large walk-in closets. Experience a lifestyle that supports both academic and personal growth at Park at Ferentino, your ideal base near Central Piedmont Community College.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Central Piedmont Community College",
      "seo_description": "Live close to Central Piedmont Community College in Charlotte at Park at Ferentino, offering modern amenities and convenient living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "generator",
      "page_item_url": "queens-university-apartments-east-forest",
      "search_query": "Queens University of Charlotte apartments East Forest",
      "category": "School",
      "h1_title": "Apartments Near Queens University, East Forest",
      "h2_subtitle": "Find ideal apartments near Queens University of Charlotte in East Forest. Park at Ferentino offers comfort and convenience.",
      "page_copy": "If you're looking for apartments near Queens University of Charlotte, Park at Ferentino in East Forest provides an excellent choice. Our location offers easy access to campus, making it perfect for students and faculty who want a short commute. Nestled in the friendly East Forest neighborhood, you can enjoy both academic and off-campus life.\n\nOur community features a fitness center with a yoga room, a sparkling swimming pool, and valet trash service, all designed to enhance your living experience. Each apartment is thoughtfully planned with generous layouts and, in most cases, large walk-in closets for ample storage. Choose Park at Ferentino for a convenient and comfortable home near Queens University of Charlotte.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Queens University, East Forest",
      "seo_description": "Discover Park at Ferentino, offering convenient apartments near Queens University of Charlotte in East Forest with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "generator",
      "page_item_url": "charlotte-christian-school-nearby-apartments",
      "search_query": "Charlotte Christian School nearby apartments Mecklenburg County",
      "category": "School",
      "h1_title": "Apartments Near Charlotte Christian School",
      "h2_subtitle": "Explore nearby apartments to Charlotte Christian School in Mecklenburg County. Discover Park at Ferentino's offerings.",
      "page_copy": "Situated in the heart of Mecklenburg County, Park at Ferentino provides convenient living just a short distance from Charlotte Christian School. Our community's location in the East Forest neighborhood ensures a quick and easy commute to school, making it an ideal choice for families and staff seeking nearby accommodations. \n\nOur apartments offer modern amenities including a refreshing swimming pool, a fitness center with a yoga room, and valet trash service. Experience spacious living with options featuring large walk-in closets, perfect for all your storage needs. Choose Park at Ferentino as your home base, balancing comfort with proximity to Charlotte Christian School.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Charlotte Christian School",
      "seo_description": "Live near Charlotte Christian School in Mecklenburg County at Park at Ferentino, offering modern amenities and convenient living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "generator",
      "page_item_url": "park-at-ferentino-near-cpcc-levine-campus",
      "search_query": "Park at Ferentino close to Central Piedmont Community College Levine Campus",
      "category": "School",
      "h1_title": "Park at Ferentino Near CPCC Levine Campus",
      "h2_subtitle": "Discover Park at Ferentino, conveniently located close to Central Piedmont Community College Levine Campus in Charlotte.",
      "page_copy": "At Park at Ferentino, you're perfectly positioned near the Central Piedmont Community College Levine Campus, making it a prime choice for students and faculty looking for nearby housing options in Charlotte. Situated in the East Forest neighborhood, our community provides the ideal blend of convenience and tranquility.\n\nEnjoy a variety of amenities designed to enhance your lifestyle, such as the fitness center with an integrated yoga room, a sparkling swimming pool, and valet trash service for added convenience. Apartments feature large walk-in closets in most floorplans, providing ample space for personal belongings. Choose Park at Ferentino for a harmonious living experience close to CPCC Levine Campus.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Park at Ferentino Near CPCC Levine Campus",
      "seo_description": "Live close to Central Piedmont Community College Levine Campus in Charlotte at Park at Ferentino with modern amenities and spacious floorplans.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "generator",
      "page_item_url": "apartments-near-atrium-health-carolinas-medical-center",
      "search_query": "apartments near Atrium Health Carolinas Medical Center Charlotte",
      "category": "Hospital",
      "h1_title": "Apartments Near Atrium Health Carolinas Medical",
      "h2_subtitle": "Find ideal apartments near Atrium Health Carolinas Medical Center in Charlotte. Park at Ferentino offers convenience and modern amenities.",
      "page_copy": "Located a short drive from Atrium Health Carolinas Medical Center, Park at Ferentino in the East Forest neighborhood of Charlotte offers convenience and comfort for healthcare professionals and employees seeking nearby living options. Our community provides a serene residential setting while ensuring easy access to the medical campus.\n\nResidents enjoy a host of amenities including a sparkling swimming pool, a state-of-the-art fitness center with a yoga room, and the added convenience of valet trash service. Many of our apartments offer large walk-in closets, giving you plenty of storage space. Experience the perfect balance of work and home life at Park at Ferentino, ideally situated near Atrium Health Carolinas Medical Center.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Atrium Health Carolinas Medical",
      "seo_description": "Park at Ferentino offers modern living options near Atrium Health Carolinas Medical Center in Charlotte with convenient amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "generator",
      "page_item_url": "apartments-near-novant-health-presbyterian-medical-center",
      "search_query": "apartments close to Novant Health Presbyterian Medical Center East Forest",
      "category": "Hospital",
      "h1_title": "Apartments Near Novant Health Presbyterian",
      "h2_subtitle": "Explore apartments close to Novant Health Presbyterian Medical Center in East Forest. Experience life at Park at Ferentino.",
      "page_copy": "Park at Ferentino offers the ideal living solution for those seeking apartments close to Novant Health Presbyterian Medical Center, located in the charming East Forest neighborhood of Charlotte. Whether you're a medical professional or a resident enjoying the local amenities, our community is perfectly situated to meet your needs.\n\nOur residents benefit from a wide range of features including a relaxing swimming pool, a comprehensive fitness center with a dedicated yoga room, and a convenient valet trash service. Many of our spacious floorplans come with large walk-in closets, providing ample storage. Choose Park at Ferentino for a balanced lifestyle with easy access to both work and leisure in East Forest.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Novant Health Presbyterian Medical",
      "seo_description": "Discover comfortable living at Park at Ferentino, with easy access to Novant Health Presbyterian Medical Center in East Forest, Charlotte.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "generator",
      "page_item_url": "apartments-near-freedom-park-charlotte",
      "search_query": "apartments near Freedom Park Charlotte",
      "category": "Park",
      "h1_title": "Apartments Near Freedom Park, Charlotte",
      "h2_subtitle": "Find your ideal living space close to Freedom Park Charlotte. Park at Ferentino offers spacious, amenity-rich apartments.",
      "page_copy": "Nestled in the vibrant East Forest neighborhood of Charlotte, Park at Ferentino offers exceptional apartments near Freedom Park. This prime location allows you to enjoy the lush landscapes and recreational activities available at one of Charlotte's favorite urban parks.\n\nOur community boasts a selection of amenities designed to enhance your lifestyle, including a sparkling swimming pool, a well-equipped fitness center with a yoga room, and convenient valet trash service. With large walk-in closets in many of our floorplans, you'll have plenty of storage space. Choose Park at Ferentino as your home to enjoy comfortable living near the scenic setting of Freedom Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Freedom Park, Charlotte",
      "seo_description": "Live near Freedom Park at Park at Ferentino in Charlotte. Enjoy modern amenities in a tranquil setting close to Charlotte’s popular park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "generator",
      "page_item_url": "apartments-near-mcalpine-creek-park-nc",
      "search_query": "apartments close to McAlpine Creek Park NC",
      "category": "Park",
      "h1_title": "Apartments Near McAlpine Creek Park, NC",
      "h2_subtitle": "Discover the perfect apartments close to McAlpine Creek Park in NC. Enjoy modern living at Park at Ferentino.",
      "page_copy": "For those who love nature and outdoor activities, Park at Ferentino offers ideal apartments close to McAlpine Creek Park, NC. Situated in the East Forest area of Charlotte, our community provides a tranquil retreat with easy access to the park's extensive trails and scenic landscapes, perfect for biking, walking, and picnicking.\n\nResidents of Park at Ferentino enjoy an array of amenities such as a refreshing swimming pool, a fully equipped fitness center with a yoga room, and the convenience of valet trash service. Each of our floorplans is designed with comfort in mind, offering large walk-in closets in most units. Experience a harmonious blend of city living with nature's serenity at Park at Ferentino.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near McAlpine Creek Park, NC",
      "seo_description": "Explore Park at Ferentino for luxurious living near McAlpine Creek Park, NC. Enjoy modern amenities and easy access to beautiful outdoor spaces.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "generator",
      "page_item_url": "apartments-by-park-road-park-28212",
      "search_query": "apartments by Park Road Park 28212",
      "category": "Park",
      "h1_title": "Apartments by Park Road Park in 28212",
      "h2_subtitle": "Looking for apartments by Park Road Park in 28212? Check out Park at Ferentino for modern living and superb amenities.",
      "page_copy": "Situated in the vibrant East Forest neighborhood of Charlotte, Park at Ferentino offers the perfect apartments by Park Road Park, within the 28212 ZIP code. This prime location allows quick access to Park Road Park's lush landscapes and recreational facilities, ideal for jogging, sports, or leisurely walks.\n\nPark at Ferentino enhances your living experience with a variety of amenities including a sparkling swimming pool, a fitness center complete with a yoga room, and valet trash services. Enjoy spacious living with large walk-in closets available in many of our floorplans. Choose Park at Ferentino for a harmonious blend of convenience, comfort, and accessibility near Park Road Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Park Road Park, Charlotte 28212",
      "seo_description": "Find your home at Park at Ferentino, located near Park Road Park in 28212. Experience great amenities and a prime location in Charlotte.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "generator",
      "page_item_url": "apartments-near-veterans-park-east-forest",
      "search_query": "apartments near Veterans Park East Forest",
      "category": "Park",
      "h1_title": "Apartments Near Veterans Park, East Forest",
      "h2_subtitle": "Explore apartments near Veterans Park in East Forest. Park at Ferentino offers prime living with excellent amenities.",
      "page_copy": "In the heart of the East Forest community, Park at Ferentino presents beautiful apartments near Veterans Park. This park-side location provides a serene setting with easy access to green spaces ideal for both relaxation and recreation.\n\nOur residents enjoy a range of amenities, including a refreshing swimming pool, a comprehensive fitness center featuring a yoga room, and the convenience of valet trash service. With large walk-in closets in many floorplans, our apartments offer the comfort and convenience you seek in East Forest. Choose Park at Ferentino for a home that perfectly balances urban living with nature's tranquility.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Veterans Park, East Forest",
      "seo_description": "Live near Veterans Park at Park at Ferentino in East Forest. Enjoy unmatched amenities in a prime Charlotte location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "generator",
      "page_item_url": "apartments-near-william-r-davie-park-mecklenburg",
      "search_query": "apartments close to William R. Davie Park Mecklenburg County",
      "category": "Park",
      "h1_title": "Apartments Close to William R. Davie Park",
      "h2_subtitle": "Discover apartments close to William R. Davie Park in Mecklenburg County. Park at Ferentino offers prime amenities and location.",
      "page_copy": "Situated in the lively East Forest neighborhood of Charlotte, Park at Ferentino provides convenient apartments close to William R. Davie Park in Mecklenburg County. This fantastic location allows you to easily enjoy the expansive green spaces and recreational activities the park offers.\n\nResidents of Park at Ferentino benefit from a host of amenities such as a sparkling swimming pool and a well-equipped fitness center with a dedicated yoga room. The community also provides valet trash service, and many floorplans feature large walk-in closets. If you seek a balance of modern living and outdoor enjoyment, Park at Ferentino is the ideal place to call home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to William R. Davie Park NC",
      "seo_description": "Experience great living at Park at Ferentino, near William R. Davie Park in Mecklenburg County. Enjoy modern amenities and a superb location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167014",
      "source": "generator",
      "page_item_url": "apartments-near-hawthorne-5th-charlotte",
      "search_query": "apartments near Hawthorne & 5th Charlotte",
      "category": "Transit",
      "h1_title": "Apartments Near Hawthorne & 5th, Charlotte",
      "h2_subtitle": "Explore apartments near Hawthorne & 5th. Park at Ferentino offers ideal living with great amenities in Charlotte.",
      "page_copy": "Nestled in Charlotte’s inviting East Forest neighborhood, Park at Ferentino offers exceptional apartments near the vibrant Hawthorne & 5th area. This popular Charlotte spot is known for its dynamic urban vibe, blending seamlessly with the tranquil living experience at our community.\n\nPark at Ferentino is equipped with amenities that cater to your lifestyle needs, including a sparkling swimming pool and a state-of-the-art fitness center complete with a yoga room. Enjoy the convenience of valet trash service and spacious living with large walk-in closets in many floorplans. Choose our community for a harmonious mix of city living and serene comfort near Hawthorne & 5th.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Hawthorne & 5th Charlotte",
      "seo_description": "Live in comfort at Park at Ferentino, close to Hawthorne & 5th, Charlotte. Experience great amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5898"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11131775359"
    },
    {
      "ID": "custom_flex_link",
      "type": "STRING",
      "value": "https://app.getflex.com/"
    },
    {
      "ID": "custom_jetty_link",
      "type": "STRING",
      "value": "https://www.jetty.com/app/login/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-TZ6W89HC"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 3"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Preferred"
    },
    {
      "ID": "custom_aim_property_code",
      "type": "STRING",
      "value": "994PAF"
    },
    {
      "ID": "custom_anyonehome_chatbot",
      "type": "STRING",
      "value": "<link rel='stylesheet' href='https://www.myshowing.com/css/omnichannel/omnichannel_communication.css'> <script src='https://www.myshowing.com/js/omnichannel/omnichannel_communication.js'></script><script text='text/javascript'>window.OmniChannel.init('hG9yGdKIfpWwqeZhDU')</script>"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "49866408232"
    },
    {
      "ID": "custom_broker_license_number",
      "type": "STRING",
      "value": "273520"
    },
    {
      "ID": "custom_website_tracking_email",
      "type": "STRING",
      "value": "amcllc_parkatferentino_gaw_googleads@leads.anyonehome.com"
    },
    {
      "ID": "custom_anyonehome_scheduler_url",
      "type": "STRING",
      "value": "https://www.myshowing.com/AMC_LLC/Park_at_Ferentino/scheduletourwidget/23suU7lQb5Cv7rKa20/"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "844-616-5398"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImpVLy84WTlrMUFNQk1LQXo0MU5tc0E9PSIsInZhbHVlIjoiR0lXUk5nTS85Y0dYdkpJZ2dSUUxaUT09IiwibWFjIjoiMDA2NWJhOGFlN2ZlZjI2NmQwYmNhZTVhMzU3YjFhNDM2ZmRjOGVlMDQwOTczYWFhMWY0NzYyNzZmZWUyYTZiMiJ9"
    }
  ],
  "custom_qb_id": "5898",
  "custom_repli_id": "11131775359",
  "custom_flex_link": "https://app.getflex.com/",
  "custom_jetty_link": "https://www.jetty.com/app/login/",
  "custom_google_gtm_id": "GTM-TZ6W89HC",
  "custom_rollout_phase": "Phase 3",
  "custom_vibesites_theme": "Preferred",
  "custom_aim_property_code": "994PAF",
  "custom_anyonehome_chatbot": "<link rel='stylesheet' href='https://www.myshowing.com/css/omnichannel/omnichannel_communication.css'> <script src='https://www.myshowing.com/js/omnichannel/omnichannel_communication.js'></script><script text='text/javascript'>window.OmniChannel.init('hG9yGdKIfpWwqeZhDU')</script>",
  "custom_hubspot_company_id": "49866408232",
  "custom_broker_license_number": "273520",
  "custom_website_tracking_email": "amcllc_parkatferentino_gaw_googleads@leads.anyonehome.com",
  "custom_anyonehome_scheduler_url": "https://www.myshowing.com/AMC_LLC/Park_at_Ferentino/scheduletourwidget/23suU7lQb5Cv7rKa20/",
  "custom_ppc_tracking_phone_number": "844-616-5398",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImpVLy84WTlrMUFNQk1LQXo0MU5tc0E9PSIsInZhbHVlIjoiR0lXUk5nTS85Y0dYdkpJZ2dSUUxaUT09IiwibWFjIjoiMDA2NWJhOGFlN2ZlZjI2NmQwYmNhZTVhMzU3YjFhNDM2ZmRjOGVlMDQwOTczYWFhMWY0NzYyNzZmZWUyYTZiMiJ9",
  "custom_audioeye_site_id": "8fb99325-ab24-4925-934c-c9804eed053e",
  "custom_audioeye_site_hash": "770a08af3dfbd7459d381e91b2aadaca"
};

export const generatedAt = '2026-10-05T17:25:09.285Z';
